import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import CustomerForm from "../CustomerForm";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { Controller, useForm } from "react-hook-form";
import NumberInput from "components/GenericComponent/NumberInput";
import NutNhanhSoTienVay from "components/GenericComponent/NutNhanhSoTienVay";
import NumberFormat from "react-number-format";
import NumberField from "components/GenericComponent/NumberField";
import ListTaiSanForm from "../ListTaiSanForm";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import UploadMultiFile1 from "components/GenericComponent/UploadMultiFile1";
import { tinhNgayTraGocv3 } from "utils/choVayUtils";
import choVayConst, {
  bindKieuLaiSuat,
  bindTypePaid,
} from "constants/choVayConst";
import ControllerTextInputTwoRow from "components/GenericComponent/ControllerTextInputTwoRow";
import ConfigConst from "constants/ConfigConst";
import { formatDayMonth } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import CamDoApi from "../../../service/camDoApi";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import CauHinhApi from "../../../service/cauHinhApi";
import ChoVayApi from "../../../service/choVayApi";
import configsRole from "utils/configsRole";
import { ModalDongLaiXemTruoc } from "components/CommonComponent/DongLaiXemTruoc";
import UserApi from "../../../service/userApi";
import { convertDate } from "../../../utils/formatDate";
import { Checkbox, notification } from "antd";
import ThuocTinhGiamTruModal from "./thuocTinhGiamTru";
import { pushNotification } from "utils/notifications";
import cauHinh from "utils/cauHinh";
import useHinhThucThanhToan from "utils/useHinhThucThanhToan";
import { getUserLogin } from "utils/user";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import Select from "react-select";
import KySoAPI from "service/In/KySoAPI";

const ChoVayForm = (props) => {
  let {
    show,
    customer,
    getAutocompleteCustomer,
    user,
    phikhac,
    phikhachangky,
    getThuocTinhTaiSan1,
    thuoctinhtaisan,
    store,
    nguonkhachhang,
    postCamDo,
    onHide,
    cauhinh,
    getDetailCustomer,
    getThuocTinhTaiSanTMCD,
    themmoicamdo,
    setTaiSanCamCo,
    setListTaiSanCamCo,
    setChoVayEdit,
    getConfigSysTMCD,
    setThuocTinhTaiSan,
    phanquyen,
    showModalLoaiTaiSan,
    inHopDong,
    inPhieuThu,
    checkEditCustomer,
    setEnableEditCustomer,
    getDetailCustomerSuccess,
    quanlycuahang,
    setIsCamDoReturn,
  } = props;
  let { comboNguonKhachHang } = nguonkhachhang;
  let {
    ThuocTinhTaiSan,
    TaiSanCamCo,
    ListTaiSanCamCo,
    ConfigTMCD,
    ListLoaiTaiSan,
    choVayEdit,
    setListPhiKhac,
    postCamDoLoading,
    postCamDoReturn,
  } = themmoicamdo;
  let { objConfig } = cauhinh;

  let objConfigSysLoaiTS = ConfigTMCD;
  let {
    LaiSuat,
    TypePaid,
    ChoVayId,
    CountTypePaid,
    BeforeAfter,
    NgayVay,
    KieuLaiSuat,
    Sotienvay,
    SoLanTra,
    SoNgayToiThieu,
    SoNgayGiaHan,
    CustomerID,
    Note,
    NgayTra,
    TongNgayVay,
    IsCopy,
    showButtonIn,
    showButtonInPhieuThu,
    ThuChiId,
    IsEditChoVay,
    IsEditCustomer,
    Code,
    LinkDinhKem,
    BocTrongVong,
    ChiPhiVay,
    PhiThanhToanSom,
    PhiBaoHiem,
    IsDuNoGiamDan,
    NgayThanhToan,
    PhiPhatTraLai,
    LoaiPhiPhatTraLai,
    PhiPhatTatToan,
    PhiPhatTatToanQuaHan,
    LoaiPhiPhatTatToan,
    SoTienThuKyDau,
    MaNhanVien,
    NgayTraGoc,
  } = choVayEdit;
  const customStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      minHeight: "32px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0px",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#3B4781",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#3B4781",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };
  const [listNhanVien, setListNhanVien] = useState([]);
  IsEditChoVay = !IsEditChoVay;
  if (choVayEdit.IsCopy) IsEditChoVay = false;
  const [isDisable, setIsDisable] = useState(false);
  // Chặn double click nút "Lưu lại": khoá lại khi request lưu đang chạy
  const isPostingRef = useRef(false);
  useEffect(() => {
    if (!postCamDoLoading) {
      isPostingRef.current = false;
    }
  }, [postCamDoLoading]);
  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [fileDinhKems, setFileDinhKems] = useState([]);
  const [linkDinhKem, setLinkDinhKem] = useState("");
  const [currentChoVay, setCurrentChoVay] = useState({});
  const [TenTaiSan1, setTenTaiSan1] = useState(null);
  const [currentCode, setCode] = useState(null);
  const [isSetPhiKhac, setIsSetPhiKhac] = useState(null);
  const [isSetPhiKhacHangKy, setIsSetPhiKhacHangKy] = useState(null);
  const [isDuNoGiamDan, setIsDuNoGiamDan] = useState(false);
  const [isFistTime, setIsFistTime] = useState(false);
  const [ChonLoaiPhiKhac, setChonLoaiPhiKhac] = useState(false);
  const [ChonLoaiPhiKhacHangKy, setChonLoaiPhiKhacHangKy] = useState(false);
  const [intLoaiPhiPhatTraLai, setLoaiPhiPhatTraLai] = useState(1);
  const [intLoaiPhiPhatTatToan, setLoaiPhiPhatTatToan] = useState(1);
  const [ListHangSanXuat, setListHangSanXuat] = useState([]);
  const [HangSanXuat, setHangSanXuat] = useState(0);
  const [ListDongSanPham, setListDongSanPham] = useState([]);
  const [DongSanPham, setDongSanPham] = useState(0);
  const [ListNamSanXuat, setListNamSanXuat] = useState([]);
  const [NamSanXuat, setNamSanXuat] = useState("0");
  const [ListSanPham, setListSanPham] = useState([]);
  const [SanPham, setSanPham] = useState(0);
  const [TenSanPham, setTenTaiSan] = useState("");
  const [GiaSanPham, setGiaSanPham] = useState(0);
  const [ListGoiVay, setListGoiVay] = useState([]);
  const [GoiVay, setGoiVay] = useState(0);
  const [ChiTietGoiVayChon, setChiTietGoiVayChon] = useState({});
  const [GiaGoiVay, setGiaGoiVay] = useState(0);
  const [useDuNoGiamDan, setUseDuNoGiamDan] = useState(false);
  const [useThamDinhTaiSan, setUseThamDinhTaiSan] = useState(false);
  const [isShowModalThuocTinhGiamTru, setShowModalThuocTinhGiamTru] =
    useState(false);
  const [ListThuocTinhGiamTru, setListThuocTinhGiamTru] = useState([]);
  const [ListThuocTinhGiamTruSelect, setListThuocTinhGiamTruSelect] = useState(
    [],
  );
  const [TongTienGiamTruSelect, setTongTienGiamTruSelect] = useState(0);
  const [isShopadmin, setisShopadmin] = useState(false);
  const [useLichThanhToan, setUseLichThanhToan] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [CanhBaoSoHopDong, setCanhBaoSoHopDong] = useState("");
  const [thamDinhHanMuc, setThamDinhHanMuc] = useState(0);
  const [camdo_inchoduyet, setInChoDuyet] = useState(false);
  const [camdo_duyettheolichsuvay, setDuyetLichSu] = useState(false);
  const [camdo_duyettheohanmucgoi, setDuyetHanMucGoi] = useState(false);
  const [camdo_duyettheohanmucchophep, setDuyetHanMucChoPhep] = useState(false);
  const [HasTatToanChoDuyet, setHasTatToanChoDuyet] = useState(0);
  const [HasKySo, setHasKySo] = useState(0);
  const batHinhThucThanhToan = useHinhThucThanhToan();
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState(0);
  useEffect(() => {
    if (!batHinhThucThanhToan || !choVayEdit.ChoVayId) return;
    let daHuy = false;
    CamDoApi.hinhThucThanhToanHopDong(choVayEdit.ChoVayId).then((response) => {
      if (!daHuy && response.status === 200 && response.data)
        setHinhThucThanhToan(response.data.HinhThucThanhToan || 0);
    });
    return () => {
      daHuy = true;
    };
  }, [batHinhThucThanhToan, choVayEdit.ChoVayId]);

  const [isCauHinhQuyTrinhPheDuyet, setIsCauHinhQuyTrinhPheDuyet] =
    useState(false);
  const [isCauHinhThamDinhTaiSanT86, setIsCauHinhThamDinhTaiSanT86] =
    useState(false);
  const [isCauHinhThamDinhTaiSanBanChung, setIsCauHinhThamDinhTaiSanBanChung] =
    useState(false);
  const [isShowGoiVay, setIsShowGoiVay] = useState(false);
  const [dataGoiVay, setDataGoiVay] = useState({});
  const [IsSuDungPhiKhacHangKy, setSuDungPhiKhacHangKy] = useState(false);
  let currentForm = useForm({
    CountTypePaid: CountTypePaid,
    Sotienvay: Sotienvay,
    SoLanTra: SoLanTra,
    SoNgayToiThieu: SoNgayToiThieu,
    SoNgayGiaHan: SoNgayGiaHan,
  });
  const { register, handleSubmit, errors, control, setValue } = currentForm; // initialize the hook
  let { objListPhiKhac } = phikhac;
  let { objListPhiKhacHangKy } = phikhachangky;
  let { CategoryId, TenTaiSan, StoreID, PhiKho, LoaiTaiSan, AnhTaiSan } =
    TaiSanCamCo;
  let { thongTinCuaHang } = quanlycuahang ? quanlycuahang : {};

  let { autocompleteData } = customer;
  let { combo } = user;
  let { objComboStore } = store;
  let ConfigPhiKho = objConfig.PhiKho;
  let {
    IsGiaHanTuDong,
    IsSoNgayTatToan,
    SoNgayMacDinhTatToan,
    ThayDoiSoNgayMacDinhTatToan,
  } = ConfigTMCD;

  const [cauHinhThuKyDau, setCauHinhThuKyDau] = useState(false);

  useEffect(() => {
    setChoVayEdit(choVayEdit);
  }, [choVayEdit.SoLanTra]);
  useEffect(() => {
    CauHinhApi.getConfigSys1().then((response) => {
      console.log(response, "aaaaaaaaaaaaaa");
      if (response.status === 200) {
        if (response.data.length > 0) {
          const isShowThuKyDau = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              configsRole.sConfig.isSoTienThuDauKy.toUpperCase(),
          );
          if (
            typeof isShowThuKyDau !== "undefined" &&
            isShowThuKyDau !== null
          ) {
            if (isShowThuKyDau.valueConfig === "1") {
              setCauHinhThuKyDau(true);
            }
          }

          const isCauHinhPheDuyet = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQuyTrinhPheDuyet.toUpperCase(),
          );
          if (isCauHinhPheDuyet != null) {
            if (isCauHinhPheDuyet.valueConfig === "1") {
              setIsCauHinhQuyTrinhPheDuyet(true);
            }
          }
          const isCauHinhThamDinhBanChung = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsCauHinhThamDinhTaiSanBanChung.toUpperCase(),
          );
          if (isCauHinhThamDinhBanChung != null) {
            if (isCauHinhThamDinhBanChung.valueConfig === "1") {
              setIsCauHinhThamDinhTaiSanBanChung(true);
              setUseThamDinhTaiSan(true);
            }
          }
          const isCauHinhShowGoiVay = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsShowGoiVay.toUpperCase(),
          );
          if (isCauHinhShowGoiVay != null) {
            if (isCauHinhShowGoiVay.valueConfig === "1") {
              setIsShowGoiVay(true);
            }
          }
          const isCauHinhT86 = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsCauHinhT86.toUpperCase(),
          );
          if (isCauHinhT86 != null) {
            if (isCauHinhT86.valueConfig === "1") {
              setIsDuNoGiamDan(true);
              setIsCauHinhThamDinhTaiSanT86(true);
              setUseThamDinhTaiSan(true);
            }
          }

          var username = getUserLogin().UserName;
          var configKey = "CamDo_ChoDuyetTheoHanMuc_HanMuc_" + username;
          const configHanMucCamDo = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configHanMucCamDo !== "undefined" &&
            configHanMucCamDo !== null
          ) {
            setThamDinhHanMuc(
              parseFloat(
                formatMoney(configHanMucCamDo.valueConfig).replaceAll(",", ""),
              ),
            );
          }
          configKey = "CamDo_InChoDuyet_" + username;
          const configRoleInChoDuyet = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleInChoDuyet !== "undefined" &&
            configRoleInChoDuyet !== null &&
            configRoleInChoDuyet.valueConfig === "1"
          ) {
            setInChoDuyet(true);
          }
          configKey = "CamDo_ChoDuyetTheoLichSu_" + username;
          const configRoleDuyetLichSuVay = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleDuyetLichSuVay !== "undefined" &&
            configRoleDuyetLichSuVay !== null &&
            configRoleDuyetLichSuVay.valueConfig === "1"
          ) {
            setDuyetLichSu(true);
          }
          configKey = "CamDo_ChoDuyetTheoHanMucGoiVay_" + username;
          const configRoleDuyetHanMucGoi = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleDuyetHanMucGoi !== "undefined" &&
            configRoleDuyetHanMucGoi !== null &&
            configRoleDuyetHanMucGoi.valueConfig === "1"
          ) {
            setDuyetHanMucGoi(true);
          }
          configKey = "CamDo_ChoDuyetTheoHanMuc_" + username;
          const configRoleDuyetHanMuc = response.data.find(
            (e) => e.keyConfig.toUpperCase() === configKey.toUpperCase(),
          );
          if (
            typeof configRoleDuyetHanMuc !== "undefined" &&
            configRoleDuyetHanMuc !== null &&
            configRoleDuyetHanMuc.valueConfig === "1"
          ) {
            setDuyetHanMucChoPhep(true);
          }
          const SuDungPhiKhacHangKy = response.data.find(
            (e) => e.keyConfig === "SuDungPhiKhacHangKy",
          );
          if (SuDungPhiKhacHangKy != null) {
            if (SuDungPhiKhacHangKy.valueConfig === "1") {
              setSuDungPhiKhacHangKy(true);
            }
          }
        }
      }
    });
    CamDoApi.getConfigCamDo("SUDUNG_DUNOGIAMDAN").then((response) => {
      setUseDuNoGiamDan(response.data.Result);
    });

    CamDoApi.getConfigCamDo("SUDUNG_LICHTHANHTOANCHIPHIVAY").then(
      (response) => {
        setUseLichThanhToan(response.data.Result);
      },
    );

    //lay danh sach nhan vien
    UserApi.combo().then((response) => {
      if (response.status === 200) {
        const users = response.data
          .filter((item) => item.value !== "0" && item.value !== "")
          .map((item) => ({
            value: item.value,
            label: item.label,
          }));
        setListNhanVien(users);
      }
    });

    UserApi.checkRole("shopadmin").then((response) => {
      setisShopadmin(response.data);
    });
  }, []);
  useEffect(() => {
    if (choVayEdit.ChoVayId > 0) {
      kiemTraHopDongChoVayTatToanChoDuyet(choVayEdit.ChoVayId);
      kiemTraHopDongChoVayKySo(choVayEdit.ChoVayId);
      if (
        choVayEdit.IsDuNoGiamDan != undefined &&
        choVayEdit.IsDuNoGiamDan != isDuNoGiamDan
      ) {
        setIsDuNoGiamDan(choVayEdit.IsDuNoGiamDan);
      }
      setLoaiPhiPhatTraLai(choVayEdit.LoaiPhiPhatTraLai);
      setLoaiPhiPhatTatToan(choVayEdit.LoaiPhiPhatTatToan);

      if (
        ListTaiSanCamCo != undefined &&
        ListTaiSanCamCo != null &&
        ListTaiSanCamCo.length > 0
      ) {
        setShowAddNewTaiSan(true);
      }
    } else if (choVayEdit.ChoVayId == undefined || choVayEdit.ChoVayId == 0) {
      if (!isLoaded) {
        CauHinhApi.getTimeServer().then((response) => {
          if (response.status === 200) {
            choVayEdit.NgayVay = convertDate(response.data.result);
          }
        });
      }

      choVayEdit.ChoVayId = 0;
      choVayEdit.LoaiPhiPhatTraLai = intLoaiPhiPhatTraLai;
      choVayEdit.LoaiPhiPhatTatToan = intLoaiPhiPhatTatToan;
      choVayEdit.ChiPhiVay = "";
      ChoVayApi.canhbaoSoLuongHopDong().then((response) => {
        if (response.status === 200 && response.data != "") {
          setCanhBaoSoHopDong(response.data);
        }
      });
      if (IsSoNgayTatToan) {
        if (
          choVayEdit.SoNgayToiThieu != ConfigTMCD.SoNgayMacDinhTatToan &&
          isFistTime == false
        ) {
          setValue("SoNgayToiThieu", ConfigTMCD.SoNgayMacDinhTatToan);
          setIsFistTime(true);
        }
      }
    }

    if (choVayEdit.NgayThanhToan === undefined) {
      choVayEdit.NgayThanhToan = choVayEdit.NgayVay;
    }

    if (currentChoVay.CountTypePaid !== CountTypePaid) {
      setValue("CountTypePaid", CountTypePaid);
      currentChoVay.CountTypePaid = CountTypePaid;
    }
    if (currentChoVay.LaiSuat !== LaiSuat) {
      setValue("LaiSuat", LaiSuat);
      currentChoVay.LaiSuat = LaiSuat;
    }
    if (currentChoVay.TypePaid !== TypePaid) {
      setValue("TypePaid", TypePaid);
      currentChoVay.TypePaid = TypePaid;
    }
    if (currentChoVay.KieuLaiSuat !== KieuLaiSuat) {
      setValue("KieuLaiSuat", KieuLaiSuat);
      currentChoVay.KieuLaiSuat = KieuLaiSuat;
    }
    if (
      currentChoVay.CountTypePaid !== CountTypePaid ||
      currentChoVay.LaiSuat !== LaiSuat ||
      currentChoVay.TypePaid !== TypePaid ||
      currentChoVay.KieuLaiSuat !== KieuLaiSuat
    )
      setCurrentChoVay(currentChoVay);
    if (
      (Code && Code !== currentCode) ||
      (showButtonIn && currentCode === null)
    ) {
      setValue("Code", Code);
      setCode(Code);
    }
    if (TenTaiSan !== TenTaiSan1) {
      setTenTaiSan1(TenTaiSan);
      setValue("ListHangTheChap[0].TenTaiSan", TenTaiSan);
      setImageTaiSans(AnhTaiSan ? AnhTaiSan.split(";") : []);
    }

    if (
      !isSetPhiKhac &&
      objListPhiKhac.length > 0 &&
      objListPhiKhac[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhac(true);
      for (let index = 0; index < objListPhiKhac.length; index++) {
        const element = objListPhiKhac[index];
        setValue("ListPhiKhac[" + index + "].GiaTri", element.GiaTri);
        setValue("ListPhiKhac[" + index + "].LoaiPhiKhac", element.LoaiPhiKhac);
        setValue(
          "ListPhiKhac[" + index + "].LoaiPhiKhacChon",
          element.LoaiPhiKhacChon,
        );
      }
    }

    if (
      !isSetPhiKhacHangKy &&
      objListPhiKhacHangKy.length > 0 &&
      objListPhiKhacHangKy[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhacHangKy(true);
      for (let index = 0; index < objListPhiKhacHangKy.length; index++) {
        const element = objListPhiKhacHangKy[index];
        setValue("ListPhiKhacHangKy[" + index + "].GiaTri", element.GiaTri);
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKy",
          element.LoaiPhiKhacHangKy,
        );
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKyChon",
          element.LoaiPhiKhacHangKyChon,
        );
      }
    }
    console.log(LaiSuat);
    if (!isLoaded) {
      if ((ListGoiVay.length === 0 && choVayEdit.ChoVayId == 0) || IsCopy) {
        getGoiVay(0);
      }
      if (choVayEdit.ChoVayId > 0) {
        loadThamDinhTaiSanTheoChoVay(choVayEdit.ChoVayId);
        CamDoApi.getPhiPhatTatToanQuaHan(choVayEdit.ChoVayId).then(
          (response) => {
            choVayEdit["PhiPhatTatToanQuaHan"] = response.data.Result;
            setChoVayEdit(choVayEdit);
          },
        );
      }

      setIsLoaded(true);
    }
    if (linkDinhKem != LinkDinhKem) {
      setFileDinhKems(LinkDinhKem ? LinkDinhKem.split(";") : []);
      setLinkDinhKem(LinkDinhKem);
    }
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeThemMoi()();
      }
    };

    // Thêm sự kiện lắng nghe khi component được mount
    document.addEventListener("keydown", handleEscape);

    // Dọn dẹp sự kiện khi component unmount
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onHide]); // eslint-disable-line react-hooks/exhaustive-deps
  const kiemTraHopDongChoVayTatToanChoDuyet = (ChoVayId) => {
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(ChoVayId).then(
      (response) => {
        if (response.data.TatToanChoDuyet) {
          setHasTatToanChoDuyet(response.data.TatToanChoDuyet);
        }
      },
    );
  };

  const kiemTraHopDongChoVayKySo = (ChoVayId) => {
    KySoAPI.kiemTraHopDongChoVayKySo(ChoVayId).then((response) => {
      if (response.data.DaKySo) {
        setHasKySo(response.data.DaKySo);
      }
    });
  };
  let NoteTaiSan = TaiSanCamCo.Note;
  let MaTaiSan = TaiSanCamCo.Code;

  const onChangeAttNumberChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setChoVayEdit(choVayEdit);
  };

  const setNhanhSoTienVay = (soTien) => {
    const giaTri = formatNumber(soTien);
    setValue("Sotienvay", giaTri, { shouldValidate: true });
    choVayEdit.Sotienvay = giaTri;
    setChoVayEdit(choVayEdit);
  };

  // Hợp đồng mới: chọn loại tài sản thì lấy Tổng tiền vay / Số ngày trả lãi (IsTongSoNgay) hoặc Số kỳ đóng lãi (lãi phẳng)
  // + Thời gian vay (dư nợ giảm dần) theo cấu hình tài sản. Tài sản dùng cấu hình nhưng bỏ trống ô thì API trả "False"
  // -> parseFloat ra NaN, giữ nguyên giá trị đang nhập
  useEffect(() => {
    if (choVayEdit.ChoVayId) return;
    const soTienVay = parseFloat(ConfigTMCD._soTienVayTinChapCamDo);
    if (soTienVay > 0) setNhanhSoTienVay(soTienVay);
    if (
      objConfig.IsTongSoNgay &&
      objConfig.OptionTinhLai !== ConfigConst.ShowDate
    ) {
      const tongSoNgay = parseFloat(ConfigTMCD._tongSoNgayTinChapCamDo);
      if (tongSoNgay > 0) {
        choVayEdit.TongNgayVay = tongSoNgay;
        setValue("TongNgayVay", tongSoNgay);
        setChoVayEdit(choVayEdit);
      }
      return;
    }
    const soLanTra = parseFloat(ConfigTMCD._soLanTraTinChapCamDo);
    if (soLanTra > 0) {
      choVayEdit.SoLanTra = soLanTra;
      choVayEdit.BocTrongVong = soLanTra;
      setValue("SoLanTra", soLanTra);
      setValue("BocTrongVong", soLanTra);
      setChoVayEdit(choVayEdit);
    }
  }, [ConfigTMCD, objConfig.IsTongSoNgay, objConfig.OptionTinhLai]); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangDuNoGiamDan = (evt) => {
    setIsDuNoGiamDan(evt.target.checked);
  };

  const onChangeAttTextChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    console.log("choVayEdit", choVayEdit);
    setChoVayEdit(choVayEdit);
  };
  const onChangeTypePaid = () => (evt) => {
    choVayEdit.TypePaid = evt.target.value;
    if (!ChoVayId)
      if (evt.target.value === "1") {
        setValue("LaiSuat", ConfigTMCD._laiSuatTinChapCamDoNgay);
      } else if (evt.target.value === "2") {
        setValue("LaiSuat", ConfigTMCD._laiSuatTinChapCamDoThang);
      }
    setChoVayEdit(choVayEdit);
  };

  let { PhanQuyenCamDo } = phanquyen;
  let {
    chonngaygiaodich,
    camdo_sudungchoduyet,
    SuDungPhiPhat_DongLai_TatToan,
    SuDungCongTacVienNhanVien,
    SuDungMaNhanVien,
    SuDungTatToanSom,
  } = PhanQuyenCamDo;

  let { OptionTinhLai, IsTongSoNgay } = objConfig;
  const GetHanMucChoPhep = () => {};
  const [isShowDongLaiXemTruoc, setIsShowDongLaiXemTruoc] = useState(false);
  const [thanhToanXemTruoc, setThanhToanXemTruoc] = useState(false);
  const unitXemTruoc = {
    TongBanGhi: 0,
    TongChiPhiVay: 0,
    TongTienGoc: 0,
    TongPhiKhac: 0,
    TongPhiKho: 0,
    TongPhiPhat: 0,
    IsDuNoGiamDan: false,
  };
  const [thongtinThanhToanXemTruoc, setThongTinThanhToanXemTruoc] =
    useState(unitXemTruoc);
  const hideThanhToanXemTruoc = () => {
    setIsShowDongLaiXemTruoc(false);
  };
  const showDongLaiXemTruoc = (dataChoVay) => {
    if (!IsEditChoVay) {
      let x = tinhNgayTraGocv3(
        parseInt(dataChoVay.SoLanTra),
        parseInt(dataChoVay.TongNgayVay),
        parseInt(dataChoVay.CountTypePaid),
        dataChoVay.NgayVay,
        parseInt(dataChoVay.TypePaid),
        1,
        false,
        dataChoVay.NgayTra,
        IsTongSoNgay,
        true,
      );
      dataChoVay.TongNgayVay = x.TongSoNgayVay;
      dataChoVay.NgayTra = x.NgayTraGoc;
      dataChoVay.SoLanTra = x.SoLanTra;
    } else {
      dataChoVay.NgayTra = formatDayMonth(NgayTra);
      dataChoVay.NgayVay = formatDayMonth(NgayVay);
      dataChoVay.SoLanTra = SoLanTra;
      dataChoVay.TypePaid = TypePaid;
    }
    dataChoVay.IsDuNoGiamDan = isDuNoGiamDan;
    CamDoApi.xemTruocLanDonglai({
      ChoVay: dataChoVay,
      ListHangTheChap: [],
      Customer: {},
      IsChoDuyet: camdo_sudungchoduyet,
      IsCopy: choVayEdit.IsCopy ? choVayEdit.IsCopy : false,
      ChoVayThamDinhTaiSan: {},
      ListChoVayThuocTinhGiamTru: [],
    }).then((response) => {
      console.log(response.data.ListPaid, "response.ListPaidresponse.ListPaid");
      setThanhToanXemTruoc(response.data.ListPaid);
      setThongTinThanhToanXemTruoc({
        ...thongtinThanhToanXemTruoc,
        TongBanGhi: response.data.TongBanGhi,
        TongChiPhiVay: response.data.TongChiPhiVay,
        TongTienGoc: response.data.TongTienGoc,
        TongPhiKhac: response.data.TongPhiKhac,
        TongPhiKho: response.data.TongPhiKho,
        TongPhiPhat: response.data.TongPhiPhat,
        TongCanThanhToan: response.data.TongCanThanhToan,
        IsDuNoGiamDan: dataChoVay.IsDuNoGiamDan,
      });
      setIsShowDongLaiXemTruoc(true);
    });
  };

  const state = {
    button: 1,
  };

  const onSubmit = (dataChoVay) => {
    // Đang gửi request lưu -> bỏ qua các lần submit tiếp theo (double click)
    if (isPostingRef.current || postCamDoLoading) {
      return;
    }
    if (state.button === 2 && useLichThanhToan) {
      showDongLaiXemTruoc(dataChoVay);
      return;
    }
    if (SanPham == 0 && useThamDinhTaiSan) {
      pushNotification("Vui lòng chọn sản phẩm", "error", "TOP_CENTER", 1000);
      return;
    }
    let sotienvaydc = parseFloat(
      formatMoney(dataChoVay.Sotienvay).replaceAll(",", ""),
    );
    if (
      !isShopadmin &&
      (isShowGoiVay == true || isCauHinhThamDinhTaiSanT86 == true)
    ) {
      if (
        parseFloat(choVayEdit["Sotienvay"]) !=
        parseFloat(formatMoney(dataChoVay.Sotienvay).replaceAll(",", ""))
      ) {
        if (parseFloat(GiaGoiVay) < sotienvaydc) {
          if (
            window.confirm(
              "Tổng tiền vay đang lớn hơn giới hạn cho vay theo gói. Hợp đồng sẽ chuyển chờ duyệt?",
            )
          ) {
            camdo_sudungchoduyet = true;
          } else {
            return;
          }
        }
      }
    }

    if (isCauHinhQuyTrinhPheDuyet && !isShopadmin) {
      if (camdo_duyettheolichsuvay && camdo_sudungchoduyet != true) {
        if (
          dataChoVay.customer.DebtLevel == "50" ||
          dataChoVay.customer.DebtLevel == "40" ||
          dataChoVay.customer.DebtLevel == "30" ||
          dataChoVay.customer.DebtLevel == "20"
        ) {
          if (
            window.confirm(
              "Khách hàng đang thuộc tình trạng nợ xấu, nợ rủi ro. Hợp đồng sẽ chuyển chờ duyệt?",
            )
          ) {
            camdo_sudungchoduyet = true;
          } else {
            return;
          }
        }
      }

      if (camdo_duyettheohanmucgoi && camdo_sudungchoduyet != true) {
        if (sotienvaydc > GiaGoiVay) {
          if (
            window.confirm(
              "Tổng tiền vay đang lớn hơn giới hạn cho vay theo gói. Hợp đồng sẽ chuyển chờ duyệt?",
            )
          ) {
            camdo_sudungchoduyet = true;
          } else {
            return;
          }
        }
      }
      if (camdo_duyettheohanmucchophep && camdo_sudungchoduyet != true) {
        if (sotienvaydc > thamDinhHanMuc) {
          if (
            window.confirm(
              "Tổng tiền vay đang lớn hơn giới hạn cho vay cho phép. Hợp đồng sẽ chuyển chờ duyệt?",
            )
          ) {
            camdo_sudungchoduyet = true;
          } else {
            return;
          }
        }
      }
    }
    if (OptionTinhLai !== ConfigConst.ShowDate) {
      dataChoVay.NgayTraGoc = null;
    }

    console.log("IsEditChoVay", IsEditChoVay);
    // if (!IsEditChoVay) {
    //   console.log("dataChoVay.TypePaid", dataChoVay.TypePaid);
    //   let x = tinhNgayTraGocv3(
    //     parseInt(dataChoVay.SoLanTra),
    //     parseInt(dataChoVay.TongNgayVay),
    //     parseInt(dataChoVay.CountTypePaid),
    //     dataChoVay.NgayVay,
    //     parseInt(dataChoVay.TypePaid),
    //     1,
    //     false,
    //     dataChoVay.NgayTra,
    //     IsTongSoNgay,
    //     true
    //   );
    //   dataChoVay.TongNgayVay = x.TongSoNgayVay;
    //   dataChoVay.NgayTra = x.NgayTraGoc;
    //   dataChoVay.SoLanTra = x.SoLanTra;
    // } else {
    debugger;

    dataChoVay.NgayVay = formatDayMonth(NgayVay);
    // dataChoVay.NgayTra = formatDayMonth(NgayTra);
    dataChoVay.TypePaid = TypePaid;
    console.log("TypePaid", TypePaid);
    // }
    let listTSpost = ListTaiSanCamCo.slice();
    if (dataChoVay.ListHangTheChap[0])
      if (LoaiTaiSan !== null && typeof LoaiTaiSan !== "undefined") {
        dataChoVay.ListHangTheChap[0].LoaiTaiSan = LoaiTaiSan;
      }
    if (TenTaiSan !== "" && typeof TenTaiSan !== "undefined") {
      dataChoVay.ListHangTheChap[0].TenTaiSan = TenTaiSan;
    }

    dataChoVay.ListHangTheChap[0].AnhTaiSan = imageTaiSans
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");
    listTSpost.unshift(dataChoVay.ListHangTheChap[0]);
    if (
      listTSpost[0].TenTaiSan === "" ||
      typeof listTSpost[0].TenTaiSan === "undefined"
    ) {
      pushNotification(
        "Vui lòng nhập tên tài sản",
        "error",
        "TOP_CENTER",
        1000,
      );
      return;
    }
    dataChoVay.FileDinhKems = fileDinhKems
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");
    if (choVayEdit.IsCopy) dataChoVay.Code = "";
    if (
      typeof choVayEdit.ImgCusNewSave != "undefined" &&
      choVayEdit.imgCusOld === dataChoVay.customer.Img
    ) {
      dataChoVay.customer.Img = choVayEdit.ImgCusNewSave;
    } else {
      choVayEdit.imgCusOld = dataChoVay.customer.Img;
    }

    dataChoVay.IsDuNoGiamDan = isDuNoGiamDan;
    var ChoVayThamDinhTaiSan1 = {
      GoiVayId: GoiVay,
      HangSanXuatID: HangSanXuat,
      DongSanPhamID: DongSanPham,
      NamSanXuat: NamSanXuat,
      SanPhamID: SanPham,
      GiaSanPhamSauTru: GiaSanPham,
      GiaGoiVaySauTru: GiaGoiVay,
      LoaiTaiSanID: TaiSanCamCo.LoaiTaiSan,
    };
    var ListChoVayThuocTinhGiamTru = ListThuocTinhGiamTruSelect;
    dataChoVay.SoNgayTinhLaiTruocHan = choVayEdit.SoNgayToiThieu;
    dataChoVay.MaNhanVien = choVayEdit.MaNhanVien;
    dataChoVay.LoaiPhiPhatTraLai = choVayEdit.LoaiPhiPhatTraLai;
    dataChoVay.LoaiPhiPhatTatToan = choVayEdit.LoaiPhiPhatTatToan;
    dataChoVay.HinhThucThanhToan = batHinhThucThanhToan
      ? parseInt(hinhThucThanhToan, 10)
      : null;
    console.log("ChoVay", dataChoVay);
    isPostingRef.current = true;
    postCamDo({
      ChoVay: dataChoVay,
      ListHangTheChap: listTSpost,
      Customer: dataChoVay.customer,
      IsChoDuyet: camdo_sudungchoduyet,
      IsCopy: choVayEdit.IsCopy ? choVayEdit.IsCopy : false,
      ChoVayThamDinhTaiSan: ChoVayThamDinhTaiSan1,
      ListChoVayThuocTinhGiamTru: ListChoVayThuocTinhGiamTru,
    });
  };
  const [showAddNewTaiSan, setShowAddNewTaiSan] = useState(false);
  const onClickShowAddNewTaiSan = () => {
    setShowAddNewTaiSan(!showAddNewTaiSan);
  };
  const onChangeLoaiTaiSan = (evt) => {
    let loaiTaiSan = evt.target.value;
    TaiSanCamCo.LoaiTaiSan = loaiTaiSan;
    getConfigSysTMCD({
      loaiTaiSan,
    });
    setTaiSanCamCo(TaiSanCamCo);
    getThuocTinhTaiSanTMCD({ loaiTaiSan });
    getHangSanXuat(loaiTaiSan, 0);
  };

  const onChangeListTaiSan = (listTaiSan) => {
    setListTaiSanCamCo(listTaiSan);
  };
  const onChangeNgayVay = (evt) => {
    choVayEdit.NgayVay = evt;
    if (isDuNoGiamDan === true) {
      choVayEdit.NgayThanhToan = evt;
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeNgayTra = (evt) => {
    choVayEdit.NgayTra = evt;
    setChoVayEdit(choVayEdit);
  };
  const onChangeNgayTraGoc = (evt) => {
    choVayEdit.NgayTraGoc = evt;
    setChoVayEdit(choVayEdit);
  };

  const onChangeNgayThanhToan = (evt) => {
    choVayEdit.NgayThanhToan = evt;
    setChoVayEdit(choVayEdit);
  };

  const onChangePhiKhac = (configId) => (evt) => {
    objListPhiKhac[configId].GiaTri = evt.value;
    // setListPhiKhac(objListPhiKhac);
  };

  const onChangeLoaiPhiPhatTraLai = (val) => (evt) => {
    setLoaiPhiPhatTraLai(val);
    choVayEdit.LoaiPhiPhatTraLai = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeLoaiPhiPhatTatToan = (val) => (evt) => {
    setLoaiPhiPhatTatToan(val);
    choVayEdit.LoaiPhiPhatTatToan = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeLoaiPhiKhac = (configId, val) => (evt) => {
    objListPhiKhac[configId].LoaiPhiKhacChon = val;
    if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    setChonLoaiPhiKhac(!ChonLoaiPhiKhac);
  };

  const onChangePhiKhacHangKy = (configId) => (evt) => {
    objListPhiKhacHangKy[configId].GiaTri = evt.value;
  };

  const onChangeLoaiPhiKhacHangKy = (configId, val) => (evt) => {
    objListPhiKhacHangKy[configId].LoaiPhiKhacHangKyChon = val;
    setChonLoaiPhiKhacHangKy(!ChonLoaiPhiKhacHangKy);
  };

  const onChangeThuocTinhTaiSan = (configId) => (evt) => {
    ThuocTinhTaiSan[configId].OptionValue = evt.target.value;
    setThuocTinhTaiSan(ThuocTinhTaiSan);
  };
  const setAttTaiSan = (field) => (evt) => {
    TaiSanCamCo[field] = evt.target.value;
    setTaiSanCamCo(TaiSanCamCo);
  };
  const closeThemMoi = () => () => {
    isPostingRef.current = false;
    setIsDisable(false);
    setTaiSanCamCo({});
    setListTaiSanCamCo([]);
    getDetailCustomerSuccess({});
    onHide();
  };

  if (postCamDoReturn) {
    setIsDisable(true);
    // onHide();
    setIsCamDoReturn();
    if (choVayEdit.lstImgTaiSanSave.length > 0) {
      setImageTaiSans(choVayEdit.lstImgTaiSanSave[0].split(";"));
    }
    var temp = ListTaiSanCamCo.map(function (elem, index) {
      elem.AnhTaiSan = choVayEdit.lstImgTaiSanSave[index + 1];
      return elem;
    });
    setListTaiSanCamCo(temp);
    setFileDinhKems(choVayEdit.ImgDinhKemSave.split(";"));

    // alert(1);
    // functionChiTietChoVay();
  }

  const loadThamDinhTaiSanTheoChoVay = (chovayId) => {
    CamDoApi.getThamDinhTaiSanTheoChoVay(chovayId).then((response) => {
      if (response.data.DataThamDinh.length > 0) {
        var dataThamDinh = response.data.DataThamDinh[0];
        LoaiTaiSan = dataThamDinh.LoaiTaiSanID;
        var listGiamTru = response.data.ListThuocTinhGiamTru;
        getHangSanXuat(dataThamDinh.LoaiTaiSanID, dataThamDinh.HangSanXuatID);
        getDongSanPham(
          dataThamDinh.LoaiTaiSanID,
          dataThamDinh.HangSanXuatID,
          dataThamDinh.DongSanPhamID,
        );
        getNamSanXuat(
          dataThamDinh.LoaiTaiSanID,
          dataThamDinh.DongSanPhamID,
          dataThamDinh.NamSanXuat,
        );
        getSanPham(
          dataThamDinh.LoaiTaiSanID,
          dataThamDinh.DongSanPhamID,
          dataThamDinh.NamSanXuat,
          dataThamDinh.SanPhamID,
        );
        getDanhSachThuocTinhGiamTru(dataThamDinh.SanPhamID);
        getGoiVay(dataThamDinh.GoiVayId);
        setGoiVay(dataThamDinh.GoiVayId);
        setGiaGoiVay(dataThamDinh.GiaGoiVaySauTru);
        setGiaSanPham(dataThamDinh.GiaSanPhamSauTru);
        setListThuocTinhGiamTruSelect(listGiamTru);
      }
    });
  };

  const getHangSanXuat = (loaiTaiSan, selectId) => {
    CamDoApi.getHangSanXuat(loaiTaiSan).then((response) => {
      setListHangSanXuat(response.data.List);
      if (response.data.List.length > 0) {
        if (selectId == 0) {
          setHangSanXuat(response.data.List[0].Id);
          getDongSanPham(loaiTaiSan, response.data.List[0].Id, 0);
        } else {
          setHangSanXuat(selectId);
        }
      }
    });
  };

  const getDongSanPham = (loaiTaiSan, hangSanXuat, selectId) => {
    CamDoApi.getDongSanPham(loaiTaiSan, hangSanXuat).then((response) => {
      setListDongSanPham(response.data.List);
      if (response.data.List.length > 0) {
        if (selectId > 0) setDongSanPham(selectId);
        else {
          setDongSanPham(response.data.List[0].Id);
          getNamSanXuat(loaiTaiSan, response.data.List[0].Id);
        }
      }
    });
  };

  const getNamSanXuat = (loaiTaiSan, dongSanPham, selectId) => {
    CamDoApi.getNamSanXuat(loaiTaiSan, dongSanPham).then((response) => {
      setListNamSanXuat(response.data.List);
      if (response.data.List.length > 0) {
        if (selectId == 0) {
          setNamSanXuat(response.data.List[0].Id);
          getSanPham(loaiTaiSan, DongSanPham, response.data.List[0].Id, 0);
        } else {
          setNamSanXuat(selectId);
        }
      }
    });
  };

  const getSanPham = (loaiTaiSan, dongSanPham, namSanXuat, selectId) => {
    CamDoApi.getSanPham(loaiTaiSan, dongSanPham, namSanXuat).then(
      (response) => {
        setListSanPham(response.data.List);
        if (response.data.List.length > 0) {
          if (selectId > 0) {
            setSanPham(selectId);
          } else {
            setSanPham(response.data.List[0].Id);
          }
        }
      },
    );
  };

  const onChangeHangSanXuat = (evt) => {
    let hangSanXuat = evt.target.value;
    setHangSanXuat(hangSanXuat);
    getDongSanPham(LoaiTaiSan, hangSanXuat, 0);
  };

  const onChangeDongSanPham = (evt) => {
    let dongSanPham = evt.target.value;
    setDongSanPham(dongSanPham);
    getNamSanXuat(LoaiTaiSan, dongSanPham, 0);
  };

  const onChangeNamSanXuat = (evt) => {
    let namSanXuat = evt.target.value;
    setNamSanXuat(namSanXuat);
    getSanPham(LoaiTaiSan, DongSanPham, namSanXuat, 0);
  };

  const onChangeSanPham = (evt) => {
    let sanPham = evt.target.value;
    setSanPham(sanPham);
    getChiTietSanPham(sanPham);
  };

  const getChiTietSanPham = (sanPham) => {
    CamDoApi.chitietSanPham(sanPham).then((response) => {
      var sanPhamDetail = response.data.Data;
      setListThuocTinhGiamTruSelect([]);
      setGiaGoiVay(GiaGoiVay + parseFloat(TongTienGiamTruSelect));
      setTongTienGiamTruSelect(0);
      if (sanPhamDetail.length > 0) {
        setTenTaiSan(sanPhamDetail[0].Ten);
        TaiSanCamCo["TenTaiSan"] = sanPhamDetail[0].Ten;
        setTaiSanCamCo(TaiSanCamCo);
        setGiaSanPham(parseFloat(sanPhamDetail[0].Gia));
        getDanhSachThuocTinhGiamTru(sanPhamDetail[0].ThongTinGiamTruID);
      } else {
        TaiSanCamCo["TenTaiSan"] = "";
        setTaiSanCamCo(TaiSanCamCo);
        setGiaSanPham(0);
        getDanhSachThuocTinhGiamTru(0);
      }
    });
  };

  const getGoiVay = (selectId) => {
    CamDoApi.getGoiVay().then((response) => {
      setListGoiVay(response.data.List);
      if (selectId > 0) {
        setGoiVay(selectId);
      } else {
        if (response.data.List.length > 0) {
          setGoiVay(response.data.List[0].Id);
        }
      }
    });
  };

  const onChangeGoiVay = (evt) => {
    let goivay = evt.target.value;
    setGoiVay(goivay);
    getChiTietGoiVay(goivay);
  };
  const getChiTietGoiVay = (goivay) => {
    CamDoApi.chitietGoiVay(goivay).then((response) => {
      var goivayDetail = response.data.Data;
      if (goivayDetail.length > 0) {
        setChiTietGoiVayChon(goivayDetail[0]);
        if (goivayDetail[0].LaiSuat > 0) {
          if (goivayDetail[0].KyDongLai != null)
            choVayEdit.CountTypePaid = goivayDetail[0].KyDongLai;

          if (goivayDetail[0].LaiSuat != null)
            choVayEdit.LaiSuat = goivayDetail[0].LaiSuat;

          if (goivayDetail[0].SoLanTra != null)
            choVayEdit.SoLanTra = goivayDetail[0].SoLanTra;

          if (goivayDetail[0].KyDongLaiLoai != null)
            choVayEdit.TypePaid = goivayDetail[0].KyDongLaiLoai;

          if (goivayDetail[0].LaiSuatKieu != null)
            choVayEdit.KieuLaiSuat = goivayDetail[0].LaiSuatKieu;
          setValue("SoLanTra", choVayEdit.SoLanTra);
          setChoVayEdit(choVayEdit);
          if (goivayDetail[0].LoaiGoiVay == "TheChap") {
            setGiaGoiVay(
              parseFloat((goivayDetail[0].HanMucGoiVay * GiaSanPham) / 100) -
                parseFloat(TongTienGiamTruSelect),
            );
          } else {
            setGiaGoiVay(
              parseFloat(goivayDetail[0].HanMucGoiVay) -
                parseFloat(TongTienGiamTruSelect),
            );
          }

          setDataGoiVay(goivayDetail[0]);
        } else {
          setGiaGoiVay(
            parseFloat(goivayDetail[0].HanMucGoiVay) -
              parseFloat(TongTienGiamTruSelect),
          );
        }
      } else {
        setGiaGoiVay(0 - parseFloat(TongTienGiamTruSelect));
        setChiTietGoiVayChon({});
      }
    });
  };

  const setModalThuocTinhGiamTru = () => {
    setShowModalThuocTinhGiamTru(!isShowModalThuocTinhGiamTru);
  };

  const getDanhSachThuocTinhGiamTru = (sanphamId) => {
    CamDoApi.getThongTinThuocTinhGiamTru(sanphamId, LoaiTaiSan).then(
      (response) => {
        setListThuocTinhGiamTru(response.data.List);
      },
    );
  };

  const xoaThuocTinhGiamTru = (giamtruId) => () => {
    // var listSelectNew = ListThuocTinhGiamTruSelect.filter(function (item) {
    //   return item.ThuocTinhGiamTruId !== giamtruId
    // })

    var tiengiamtruconglai = 0;
    var thuoctinhSelect = [];
    var tongtiengiamtru = 0;
    ListThuocTinhGiamTruSelect &&
      ListThuocTinhGiamTruSelect.map((item, idx) => {
        if (parseInt(item.ThuocTinhGiamTruId) !== parseInt(giamtruId)) {
          //alert(item.ThuocTinhGiamTruId)
          thuoctinhSelect.push(item);
          tongtiengiamtru += parseFloat(item.TienGiamTru);
        } else {
          tiengiamtruconglai += parseFloat(item.TienGiamTru);
        }
      });

    var giagoivay = parseFloat(GiaGoiVay) + parseFloat(tiengiamtruconglai);
    var giasanpham = parseFloat(GiaSanPham) + parseFloat(tiengiamtruconglai);
    setGiaGoiVay(giagoivay);
    setGiaSanPham(giasanpham);
    setListThuocTinhGiamTruSelect(thuoctinhSelect);
    setTongTienGiamTruSelect(tongtiengiamtru);
  };

  return (
    <Modal
      show={show}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <div
        className={
          "loader loader-default " + (postCamDoLoading ? "is-active" : "")
        }
      ></div>
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          {IsCopy ? "Sao chép " : ChoVayId > 0 ? "Thay đổi " : "Thêm mới "} hợp
          đồng cầm đồ
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={closeThemMoi()}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <div
        className={
          "loader loader-default " + (postCamDoLoading ? "is-active" : "")
        }
      ></div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body
          style={{ padding: "0px", background: "#F4F5FA !important" }}
        >
          <div className="form tat-toan form-horizontal form-edit thoimoihopdong">
            <div className="form-body">
              {HasTatToanChoDuyet === 1 && (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="thongbaotattoan">
                        HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                      </div>
                    </div>
                  </div>
                </>
              )}
              {HasKySo === 1 && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="thongbaotattoan">
                      HỢP ĐỒNG ĐÃ ĐƯỢC KÝ SỐ
                    </div>
                  </div>
                </div>
              )}
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse196"
                  className="card-header"
                  data-toggle="collapse"
                  href="#collapse196"
                  aria-expanded="true"
                  aria-controls="collapse196"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin khách vay</h3>
                  </a>
                </div>
                <div
                  id="collapse196"
                  role="tabpanel"
                  aria-labelledby="headingCollapse96"
                  className="card-collapse collapse show"
                >
                  <CustomerForm
                    customerId={CustomerID}
                    currentForm={currentForm}
                    autocompleteData={autocompleteData}
                    getAutocompleteCustomer={getAutocompleteCustomer}
                    userCombo={combo}
                    comboNguonKhachHang={comboNguonKhachHang}
                    customer={customer}
                    getDetailCustomer={getDetailCustomer}
                    errors={errors}
                    IsEditCustomer={IsEditCustomer}
                    checkEditCustomer={checkEditCustomer}
                    setEnableEditCustomer={setEnableEditCustomer}
                    IsCopy={IsCopy}
                    CodeCuaHang={thongTinCuaHang.Code}
                  ></CustomerForm>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                {isCauHinhThamDinhTaiSanT86 == true && (
                  <>
                    <div
                      id="headingCollapse200"
                      className="card-header mt-1 mt-1"
                      data-toggle="collapse"
                      href="#collapse200"
                      aria-expanded="true"
                      aria-controls="collapse194"
                      style={{ display: useThamDinhTaiSan ? "" : "none" }}
                    >
                      <a
                        className="card-title lead info collapsed"
                        href={() => false}
                      >
                        <h3>Thẩm định tài sản</h3>
                      </a>
                    </div>
                    <div
                      id="collapse200"
                      role="tabpanel"
                      aria-labelledby="headingCollapse200"
                      className="card-collapse collapse show"
                      style={{ display: useThamDinhTaiSan ? "" : "none" }}
                    >
                      <div className="card-content">
                        <div className="card-body">
                          <div
                            className="col-md-12"
                            style={{
                              padding: "5px",
                              border: "1px",
                              borderStyle: "solid",
                              borderColor: "#CACFE7",
                              position: "initial",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "10px",
                            }}
                          >
                            <div className="row">
                              <div className="form-mobile-ts">
                                <div
                                  className="col-md-2"
                                  style={{
                                    paddingRight: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <select
                                    name="ListHangTheChap[0].LoaiTaiSan"
                                    className="form-control input-sm"
                                    ref={register}
                                    value={LoaiTaiSan}
                                    onChange={onChangeLoaiTaiSan}
                                    defaultValue={LoaiTaiSan}
                                    disabled={IsEditChoVay}
                                    style={{ border: "0px", borderRadius: "0" }}
                                  >
                                    <option key={"comboLoaiTaiSan0"} value="0">
                                      Loại tài sản
                                    </option>
                                    {ListLoaiTaiSan &&
                                      ListLoaiTaiSan.map((item, idx) => (
                                        <option
                                          key={"comboLoaiTaiSan" + idx}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div
                                  className="col-md-2"
                                  style={{
                                    padding: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <select
                                    className="form-control input-sm"
                                    ref={register}
                                    value={HangSanXuat}
                                    onChange={onChangeHangSanXuat}
                                    defaultValue={HangSanXuat}
                                    disabled={IsEditChoVay}
                                    style={{ border: "0px", borderRadius: "0" }}
                                  >
                                    {ListHangSanXuat &&
                                      ListHangSanXuat.map((item, idx) => (
                                        <option
                                          key={"comboHangSanXuat" + idx}
                                          value={item.Id}
                                        >
                                          {item.Value}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div
                                  className="col-md-2"
                                  style={{
                                    padding: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <Select
                                    styles={customStyles}
                                    options={
                                      ListDongSanPham
                                        ? ListDongSanPham.map((item) => ({
                                            value: item.Id,
                                            label: item.Value,
                                          }))
                                        : []
                                    }
                                    value={
                                      ListDongSanPham
                                        ? ListDongSanPham.map((item) => ({
                                            value: item.Id,
                                            label: item.Value,
                                          })).find(
                                            (x) =>
                                              String(x.value) ===
                                              String(DongSanPham),
                                          )
                                        : null
                                    }
                                    onChange={(e) =>
                                      onChangeDongSanPham({
                                        target: { value: e.value },
                                      })
                                    }
                                    isDisabled={IsEditChoVay}
                                    placeholder="Chọn dòng SP..."
                                  />
                                </div>
                                <div
                                  className="col-md-1"
                                  style={{
                                    padding: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <select
                                    className="form-control input-sm"
                                    ref={register}
                                    value={NamSanXuat}
                                    onChange={onChangeNamSanXuat}
                                    defaultValue={NamSanXuat}
                                    disabled={IsEditChoVay}
                                    style={{ border: "0px", borderRadius: "0" }}
                                  >
                                    {ListNamSanXuat &&
                                      ListNamSanXuat.map((item, idx) => (
                                        <option
                                          key={"comboNamSanXuat" + idx}
                                          value={item.Id}
                                        >
                                          {item.Value}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div
                                  className="col-md-5"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  <Select
                                    styles={customStyles}
                                    options={
                                      ListSanPham
                                        ? ListSanPham.map((item) => ({
                                            value: item.Id,
                                            label: item.Value,
                                          }))
                                        : []
                                    }
                                    value={
                                      ListSanPham
                                        ? ListSanPham.map((item) => ({
                                            value: item.Id,
                                            label: item.Value,
                                          })).find(
                                            (x) =>
                                              String(x.value) ===
                                              String(SanPham),
                                          )
                                        : null
                                    }
                                    onChange={(e) =>
                                      onChangeSanPham({
                                        target: { value: e.value },
                                      })
                                    }
                                    isDisabled={IsEditChoVay}
                                    placeholder="Chọn hoặc tìm sản phẩm..."
                                  />
                                </div>
                                {/* <div
                                  className="col-md-5"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  <select
                                    className="form-control input-sm"
                                    ref={register}
                                    value={SanPham}
                                    onChange={onChangeSanPham}
                                    defaultValue={SanPham}
                                    disabled={IsEditChoVay}
                                    style={{
                                      border: "0px",
                                      borderRadius: "0",
                                      textTransform: "unset",
                                    }}
                                  >
                                    {" "}
                                    {ListSanPham &&
                                      ListSanPham.map((item, idx) => (
                                        <option
                                          key={"comboSanPham" + idx}
                                          value={item.Id}
                                        >
                                          {" "}
                                          {item.Value}{" "}
                                        </option>
                                      ))}{" "}
                                    {ListSanPham == undefined && (
                                      <option key="comboSanPham0" value="0">
                                        {" "}
                                        Tên sản phẩm{" "}
                                      </option>
                                    )}{" "}
                                  </select>{" "}
                                </div> */}

                                {/* <a
                                href={() => false}
                                onClick={() => showModalLoaiTaiSan(true)}
                              >
                                <span className="ad-ts">
                                  <i className="mdi mdi-plus"></i>
                                </span>
                              </a> */}
                              </div>
                            </div>
                          </div>

                          {SanPham != undefined && SanPham > 0 && (
                            <div
                              className="col-md-12"
                              style={{
                                marginTop: "10px",
                                color: "#000",
                                borderRadius: "10px",
                                border: "1px",
                                borderStyle: "solid",
                                borderColor: "#CACFE7",
                              }}
                            >
                              <div
                                className="row"
                                style={{
                                  minHeight: "30px",
                                  padding: "10px 0px 10px 0px",
                                }}
                              >
                                <div
                                  className="col-md-6 color7-bold"
                                  style={{ marginBottom: "10px" }}
                                >
                                  Thuộc tính giảm trừ
                                </div>
                                <div
                                  className="col-md-6 "
                                  style={{
                                    textAlign: "right",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {(ListThuocTinhGiamTruSelect == undefined ||
                                    ListThuocTinhGiamTruSelect.length == 0 ||
                                    IsEditChoVay) && (
                                    <a style={{ color: "#00B69B" }}>
                                      <i class="mdi mdi-pencil color7"></i> Sửa
                                      thuộc tính
                                    </a>
                                  )}
                                  {ListThuocTinhGiamTruSelect &&
                                    ListThuocTinhGiamTruSelect.length > 0 &&
                                    !IsEditChoVay && (
                                      <a
                                        style={{ color: "#00B69B" }}
                                        onClick={setModalThuocTinhGiamTru}
                                      >
                                        <i class="mdi mdi-pencil"></i> Sửa thuộc
                                        tính
                                      </a>
                                    )}
                                </div>
                                <div
                                  class="col-md-12 color-xanh-bold"
                                  style={{ marginBottom: "10px" }}
                                >
                                  {ListThuocTinhGiamTruSelect &&
                                    ListThuocTinhGiamTruSelect.length > 0 &&
                                    ListThuocTinhGiamTruSelect.map(
                                      (item, idx) => (
                                        <div
                                          style={{
                                            border: "1px",
                                            borderStyle: "solid",
                                            borderColor: "#DDDDDD",
                                            margin: "3px",
                                            padding: "8px",
                                            minWidth: "100px",
                                            float: "left",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          {item.TenThuocTinh}
                                          {!IsEditChoVay && (
                                            <a
                                              onClick={xoaThuocTinhGiamTru(
                                                item.ThuocTinhGiamTruId,
                                              )}
                                              style={{
                                                float: "right",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              <i
                                                className="mdi mdi-close-circle color-do-bold"
                                                style={{
                                                  fontSize: "15px",
                                                  paddingTop: "-5px",
                                                }}
                                              ></i>
                                            </a>
                                          )}
                                        </div>
                                      ),
                                    )}

                                  {ListThuocTinhGiamTruSelect == undefined ||
                                    (ListThuocTinhGiamTruSelect.length == 0 && (
                                      <a
                                        style={{ color: "#00B69B" }}
                                        onClick={setModalThuocTinhGiamTru}
                                      >
                                        Chọn thuộc tính
                                      </a>
                                    ))}
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="col-md-12">
                            <div className="row" style={{ marginTop: "10px" }}>
                              <div
                                className="col-md-3"
                                style={{ paddingLeft: "0px" }}
                              >
                                <select
                                  className="form-control input-sm"
                                  ref={register}
                                  value={GoiVay}
                                  onChange={onChangeGoiVay}
                                  defaultValue={GoiVay}
                                  disabled={IsEditChoVay}
                                >
                                  {ListGoiVay &&
                                    ListGoiVay.map((item, idx) => (
                                      <option
                                        key={"comboGoiVay" + idx}
                                        value={item.Id}
                                      >
                                        {item.Value}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div
                                className="col-md-9"
                                style={{
                                  backgroundColor: "#E7F9E9",
                                  color: "#000",
                                  borderRadius: "10px",
                                  border: "1px",
                                  borderStyle: "solid",
                                  borderColor: "#CACFE7",
                                  display: "flex",
                                }}
                              >
                                <div
                                  className="row"
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div className="col-md-6">
                                    Giá sau giảm trừ:{" "}
                                    <b>{formatNumber(GiaSanPham)}</b>
                                  </div>
                                  <div className="col-md-6">
                                    Giá cho vay tối đa:{" "}
                                    <b className="color-do-bold">
                                      {formatNumber(GiaGoiVay)}
                                    </b>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {isCauHinhThamDinhTaiSanBanChung == true && (
                  <>
                    <div
                      id="headingCollapse200"
                      className="card-header mt-1 mt-1"
                      data-toggle="collapse"
                      href="#collapse200"
                      aria-expanded="true"
                      aria-controls="collapse194"
                      style={{ display: useThamDinhTaiSan ? "" : "none" }}
                    >
                      <a
                        className="card-title lead info collapsed"
                        href={() => false}
                      >
                        <h3>Thẩm định tài sản</h3>
                      </a>
                    </div>
                    <div
                      id="collapse200"
                      role="tabpanel"
                      aria-labelledby="headingCollapse200"
                      className="card-collapse collapse show"
                      style={{ display: useThamDinhTaiSan ? "" : "none" }}
                    >
                      <div className="card-content">
                        <div className="card-body">
                          <div
                            className="col-md-12"
                            style={{
                              padding: "5px",
                              border: "1px",
                              borderStyle: "solid",
                              borderColor: "#CACFE7",
                              position: "initial",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "10px",
                            }}
                          >
                            <div className="row">
                              <div className="form-mobile-ts">
                                <div
                                  className="col-md-2"
                                  style={{
                                    paddingRight: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <select
                                    name="ListHangTheChap[0].LoaiTaiSan"
                                    className="form-control input-sm"
                                    ref={register}
                                    value={LoaiTaiSan}
                                    onChange={onChangeLoaiTaiSan}
                                    defaultValue={LoaiTaiSan}
                                    disabled={IsEditChoVay}
                                    style={{ border: "0px", borderRadius: "0" }}
                                  >
                                    <option key={"comboLoaiTaiSan0"} value="0">
                                      Loại tài sản
                                    </option>
                                    {ListLoaiTaiSan &&
                                      ListLoaiTaiSan.map((item, idx) => (
                                        <option
                                          key={"comboLoaiTaiSan" + idx}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div
                                  className="col-md-2"
                                  style={{
                                    padding: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <select
                                    className="form-control input-sm"
                                    ref={register}
                                    value={HangSanXuat}
                                    onChange={onChangeHangSanXuat}
                                    defaultValue={HangSanXuat}
                                    disabled={IsEditChoVay}
                                    style={{ border: "0px", borderRadius: "0" }}
                                  >
                                    {ListHangSanXuat &&
                                      ListHangSanXuat.map((item, idx) => (
                                        <option
                                          key={"comboHangSanXuat" + idx}
                                          value={item.Id}
                                        >
                                          {item.Value}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div
                                  className="col-md-2"
                                  style={{
                                    padding: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <select
                                    className="form-control input-sm"
                                    ref={register}
                                    value={DongSanPham}
                                    onChange={onChangeDongSanPham}
                                    defaultValue={DongSanPham}
                                    style={{ border: "0px", borderRadius: "0" }}
                                    disabled={IsEditChoVay}
                                  >
                                    {ListDongSanPham &&
                                      ListDongSanPham.map((item, idx) => (
                                        <option
                                          key={"comboDongSanPham" + idx}
                                          value={item.Id}
                                        >
                                          {item.Value}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div
                                  className="col-md-1"
                                  style={{
                                    padding: "0px",
                                    borderRight: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "#CACFE7",
                                  }}
                                >
                                  <select
                                    className="form-control input-sm"
                                    ref={register}
                                    value={NamSanXuat}
                                    onChange={onChangeNamSanXuat}
                                    defaultValue={NamSanXuat}
                                    disabled={IsEditChoVay}
                                    style={{ border: "0px", borderRadius: "0" }}
                                  >
                                    {ListNamSanXuat &&
                                      ListNamSanXuat.map((item, idx) => (
                                        <option
                                          key={"comboNamSanXuat" + idx}
                                          value={item.Id}
                                        >
                                          {item.Value}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div
                                  className="col-md-5"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  <select
                                    className="form-control input-sm"
                                    ref={register}
                                    value={SanPham}
                                    onChange={onChangeSanPham}
                                    defaultValue={SanPham}
                                    disabled={IsEditChoVay}
                                    style={{
                                      border: "0px",
                                      borderRadius: "0",
                                      textTransform: "unset",
                                    }}
                                  >
                                    {ListSanPham &&
                                      ListSanPham.map((item, idx) => (
                                        <option
                                          key={"comboSanPham" + idx}
                                          value={item.Id}
                                        >
                                          {item.Value}
                                        </option>
                                      ))}
                                    {ListSanPham == undefined && (
                                      <option key="comboSanPham0" value="0">
                                        Tên sản phẩm
                                      </option>
                                    )}
                                  </select>
                                </div>

                                {/* <a
                                href={() => false}
                                onClick={() => showModalLoaiTaiSan(true)}
                              >
                                <span className="ad-ts">
                                  <i className="mdi mdi-plus"></i>
                                </span>
                              </a> */}
                              </div>
                            </div>
                          </div>

                          {SanPham != undefined && SanPham > 0 && (
                            <div
                              className="col-md-12"
                              style={{
                                marginTop: "10px",
                                color: "#000",
                                borderRadius: "10px",
                                border: "1px",
                                borderStyle: "solid",
                                borderColor: "#CACFE7",
                              }}
                            >
                              <div
                                className="row"
                                style={{
                                  minHeight: "30px",
                                  padding: "10px 0px 10px 0px",
                                }}
                              >
                                <div
                                  className="col-md-6 color7-bold"
                                  style={{ marginBottom: "10px" }}
                                >
                                  Thuộc tính giảm trừ
                                </div>
                                <div
                                  className="col-md-6 "
                                  style={{
                                    textAlign: "right",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {(ListThuocTinhGiamTruSelect == undefined ||
                                    ListThuocTinhGiamTruSelect.length == 0 ||
                                    IsEditChoVay) && (
                                    <a style={{ color: "#00B69B" }}>
                                      <i class="mdi mdi-pencil"></i> Sửa thuộc
                                      tính
                                    </a>
                                  )}
                                  {ListThuocTinhGiamTruSelect &&
                                    ListThuocTinhGiamTruSelect.length > 0 &&
                                    !IsEditChoVay && (
                                      <a
                                        style={{ color: "#00B69B" }}
                                        onClick={setModalThuocTinhGiamTru}
                                      >
                                        <i class="mdi mdi-pencil"></i> Sửa thuộc
                                        tính
                                      </a>
                                    )}
                                </div>
                                <div
                                  class="col-md-12 color-xanh-bold"
                                  style={{ marginBottom: "10px" }}
                                >
                                  {ListThuocTinhGiamTruSelect &&
                                    ListThuocTinhGiamTruSelect.length > 0 &&
                                    ListThuocTinhGiamTruSelect.map(
                                      (item, idx) => (
                                        <div
                                          style={{
                                            border: "1px",
                                            borderStyle: "solid",
                                            borderColor: "#DDDDDD",
                                            margin: "3px",
                                            padding: "8px",
                                            minWidth: "100px",
                                            float: "left",
                                            borderRadius: "10px",
                                          }}
                                        >
                                          {item.TenThuocTinh}
                                          {!IsEditChoVay && (
                                            <a
                                              onClick={xoaThuocTinhGiamTru(
                                                item.ThuocTinhGiamTruId,
                                              )}
                                              style={{
                                                float: "right",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              <i
                                                className="mdi mdi-close-circle color-do-bold"
                                                style={{
                                                  fontSize: "15px",
                                                  paddingTop: "-5px",
                                                }}
                                              ></i>
                                            </a>
                                          )}
                                        </div>
                                      ),
                                    )}

                                  {ListThuocTinhGiamTruSelect == undefined ||
                                    (ListThuocTinhGiamTruSelect.length == 0 && (
                                      <a
                                        style={{ color: "#00B69B" }}
                                        onClick={setModalThuocTinhGiamTru}
                                      >
                                        Chọn thuộc tính
                                      </a>
                                    ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse194"
                  className="card-header mt-1 mt-1"
                  data-toggle="collapse"
                  href="#collapse194"
                  aria-expanded="true"
                  aria-controls="collapse194"
                  display={useThamDinhTaiSan == false ? "none" : ""}
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin cho vay</h3>
                  </a>
                </div>

                <div
                  id="collapse194"
                  role="tabpanel"
                  aria-labelledby="headingCollapse94"
                  className="card-collapse collapse show"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <input
                          type="hidden"
                          name="ChoVayId"
                          value={ChoVayId}
                          ref={register}
                        ></input>

                        <>
                          <div
                            className="col-md-12 col-lg-12"
                            style={{
                              display: useDuNoGiamDan ? "" : "none",
                            }}
                          >
                            <div className="col-md-6 ">
                              <input
                                id="chkDuNoGiamDan"
                                type="checkbox"
                                onChange={onChangDuNoGiamDan}
                                checked={isDuNoGiamDan}
                                disabled={ChoVayId}
                              ></input>
                              <label
                                for="chkDuNoGiamDan"
                                className="color7-bold"
                              >
                                &nbsp;Sử dụng dư nợ giảm dần
                              </label>
                            </div>
                          </div>
                        </>

                        <div className="col-md-12 col-lg-12">
                          <div className="row thongtinchovay-v2">
                            {isShowGoiVay == true && (
                              <>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Gói vay{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <div>
                                    <fieldset>
                                      <div className="input-group input-icon">
                                        <select
                                          className="form-control input-sm"
                                          ref={register}
                                          value={GoiVay}
                                          onChange={onChangeGoiVay}
                                          defaultValue={GoiVay}
                                          disabled={IsEditChoVay}
                                        >
                                          {ListGoiVay &&
                                            ListGoiVay.map((item, idx) => (
                                              <option
                                                key={"comboGoiVay" + idx}
                                                value={item.Id}
                                              >
                                                {item.Value}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                    </fieldset>
                                  </div>

                                  {GiaSanPham != 0 && (
                                    <div className="col-md-4">
                                      <i
                                        style={{
                                          fontSize: "13px",
                                          color: "#000000",
                                        }}
                                      >
                                        Giá sau giảm trừ:{" "}
                                        <b>{formatNumber(GiaSanPham)}</b>
                                      </i>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}

                            {!useThamDinhTaiSan && (
                              <>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Tên tài sản{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <fieldset>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        value={TenTaiSan}
                                        className="form-control input-sm"
                                        onChange={setAttTaiSan("TenTaiSan")}
                                        ref={register}
                                      ></input>
                                    </div>
                                  </fieldset>
                                </div>

                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Loại tài sản{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <br />
                                  <select
                                    name="ListHangTheChap[0].LoaiTaiSan"
                                    className="form-control input-sm col-md-12  select-v2"
                                    ref={register}
                                    value={LoaiTaiSan}
                                    onChange={onChangeLoaiTaiSan}
                                    defaultValue={LoaiTaiSan}
                                    disabled={IsEditChoVay}
                                  >
                                    {ListLoaiTaiSan &&
                                      ListLoaiTaiSan.map((item, idx) => (
                                        <option
                                          key={"comboLoaiTaiSan" + idx}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    &nbsp;
                                  </label>
                                  <br />
                                  <div>
                                    <button
                                      type="button"
                                      className="btn-them-moi-ts"
                                      onClick={() => showModalLoaiTaiSan(true)}
                                      style={{ margin: "0px" }}
                                    >
                                      <i className="mdi mdi-plus"></i>{" "}
                                      <span
                                        style={{
                                          fontSize: "15px",
                                        }}
                                      >
                                        Thêm mới loại tài sản
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                          <div className="row thongtinchovay-v2">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Ngày vay <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <DateTimePicker
                                onChange={onChangeNgayVay}
                                value={NgayVay}
                                name="NgayVay"
                                customInputRef={register}
                                customInput={
                                  <input name="NgayVay" ref={register}></input>
                                }
                                readOnly={IsEditChoVay || !chonngaygiaodich}
                              ></DateTimePicker>
                            </div>
                            {isDuNoGiamDan == true && (
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  {" "}
                                  Ngày bắt đầu tính lãi{" "}
                                  <span className="canh-bao-red">*</span>
                                </label>
                                <br />
                                <div>
                                  <DateTimePicker
                                    onChange={onChangeNgayThanhToan}
                                    value={NgayThanhToan}
                                    customInputRef={register}
                                    readOnly={IsEditChoVay}
                                    name="NgayThanhToan"
                                    customInput={
                                      <input
                                        name="NgayThanhToan"
                                        ref={register}
                                      ></input>
                                    }
                                  ></DateTimePicker>
                                </div>
                              </div>
                            )}

                            {!IsCopy && (
                              <div className="col-md-4">
                                <TextInputTwoRow
                                  labelClass="col-md-2 label-control"
                                  inputClass="form-control input-sm"
                                  wrapperClass="form-group row"
                                  labelText="Mã hợp đồng"
                                  placeholder="Mã hợp đồng"
                                  inputProps={{
                                    ref: register,
                                    name: "Code",
                                    readOnly: IsEditChoVay,
                                  }}
                                ></TextInputTwoRow>
                              </div>
                            )}
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-md-4">
                                  <NumberInput
                                    labelClass="col-md-4 label-control"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-8"
                                    wrapperClass="row"
                                    labelText="Tổng tiền vay"
                                    starRed="*"
                                    placeholder="10,000,000"
                                    inputProps={{
                                      name: "Sotienvay",
                                      value: Sotienvay,
                                      onChange:
                                        onChangeAttNumberChoVay("Sotienvay"),
                                      rules: {
                                        required: "Hãy nhập số tiền vay",
                                      },
                                      control: control,
                                      readOnly: IsEditChoVay,
                                    }}
                                    error={errors.Sotienvay}
                                  ></NumberInput>
                                  {(isShowGoiVay == true ||
                                    isCauHinhThamDinhTaiSanT86 == true) && (
                                    <div className="col-md-12 color-cam">
                                      <i style={{ fontSize: "13px" }}>
                                        (Tổng tiền vay không được quá{" "}
                                        {formatNumber(GiaGoiVay)})
                                      </i>
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-8">
                                  <NutNhanhSoTienVay
                                    getValue={() =>
                                      currentForm.getValues("Sotienvay")
                                    }
                                    onChange={setNhanhSoTienVay}
                                    disabled={IsEditChoVay}
                                  />
                                </div>
                              </div>
                            </div>
                            {isDuNoGiamDan == true && (
                              <>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Thời gian vay
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <br />
                                  <NumberField
                                    className="form-control input-sm"
                                    name={"BocTrongVong"}
                                    value={BocTrongVong}
                                    onChange={onChangeAttNumberChoVay(
                                      "BocTrongVong",
                                    )}
                                    placeholder={"50"}
                                    readOnly={IsEditChoVay}
                                    inputRef={register({
                                      required: "Hãy nhập thời gian vay",
                                    })}
                                  ></NumberField>
                                  {errors.BocTrongVong && (
                                    <span className="canh-bao-red">
                                      {errors.BocTrongVong.message}
                                    </span>
                                  )}
                                </div>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    {isDuNoGiamDan
                                      ? "Chi phí vay/tháng(%)"
                                      : "Chi phí vay"}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <br />
                                  <Controller
                                    name="ChiPhiVay"
                                    rules={{
                                      required: "Hãy nhập số",
                                    }}
                                    control={control}
                                    readOnly={IsEditChoVay}
                                    defaultValue={ChiPhiVay}
                                    className="form-control input-sm"
                                    as={NumberFormat}
                                    placeholder={"%"}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Phí thanh toán sớm
                                  </label>
                                  <br />
                                  <Controller
                                    name="PhiThanhToanSom"
                                    control={control}
                                    defaultValue={PhiThanhToanSom}
                                    className="form-control input-sm"
                                    as={NumberFormat}
                                    readOnly={IsEditChoVay}
                                    placeholder={"%"}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Phí bảo hiểm
                                  </label>
                                  <br />
                                  <Controller
                                    name="PhiBaoHiem"
                                    control={control}
                                    readOnly={IsEditChoVay}
                                    defaultValue={PhiBaoHiem}
                                    className="form-control input-sm"
                                    as={NumberFormat}
                                    placeholder={"%"}
                                  />
                                </div>
                              </>
                            )}

                            {(isDuNoGiamDan == undefined ||
                              isDuNoGiamDan == false) && (
                              <>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Kỳ đóng lãi{" "}
                                    <span className="canh-bao-red">
                                      *
                                      <PopoversBootrap
                                        contentText="10 ngày/tháng đóng lãi 1 lần thì điền số 10"
                                        titleText=""
                                        trigger={["hover", "focus"]}
                                        placement={"top"}
                                      >
                                        <i className="la la-question-circle tool-comment"></i>
                                      </PopoversBootrap>
                                    </span>
                                  </label>
                                  <br />
                                  <div class="row">
                                    <div
                                      className="col-md-7 "
                                      style={{ paddingRight: "0px" }}
                                    >
                                      <Controller
                                        name="CountTypePaid"
                                        rules={{
                                          required: "Hãy nhập kỳ đóng lãi",
                                        }}
                                        control={control}
                                        defaultValue={CountTypePaid}
                                        className="form-control left input-sm"
                                        as={NumberFormat}
                                        // placeholder="%"
                                        disabled={IsEditChoVay}
                                      />
                                      <span className="canh-bao-red">
                                        {errors.CountTypePaid &&
                                          errors.CountTypePaid.message}
                                      </span>
                                    </div>
                                    <div
                                      className="col-md-5"
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      <select
                                        name="TypePaid"
                                        ref={register}
                                        className="form-control right  input-sm select-v2"
                                        onChange={onChangeTypePaid()}
                                        value={TypePaid}
                                        defaultValue={TypePaid}
                                        disabled={IsEditChoVay}
                                      >
                                        {bindTypePaid(objConfigSysLoaiTS)}
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Lãi suất{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <br />
                                  <div class="row">
                                    <div
                                      className="col-md-7"
                                      style={{ paddingRight: "0px" }}
                                    >
                                      <Controller
                                        name="LaiSuat"
                                        rules={{
                                          required: "Hãy nhập lãi suất",
                                        }}
                                        control={control}
                                        readOnly={IsEditChoVay}
                                        defaultValue={LaiSuat}
                                        className="form-control left input-sm "
                                        // onChange, onBlur, value, name, ref inejcted to the component
                                        as={NumberFormat}
                                        placeholder={
                                          parseFloat(TypePaid) === 3
                                            ? "%"
                                            : choVayConst
                                                .KieuLaiSuatPlaceholder[
                                                KieuLaiSuat
                                              ]
                                        }
                                      />
                                      <span className="canh-bao-red">
                                        {errors.LaiSuat &&
                                          errors.LaiSuat.message}
                                      </span>
                                    </div>
                                    <div
                                      className="col-md-5"
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      {parseFloat(TypePaid) !== 3 && (
                                        <select
                                          name="KieuLaiSuat"
                                          ref={register}
                                          className="form-control  right input-sm select-v2"
                                          onChange={onChangeAttTextChoVay(
                                            "KieuLaiSuat",
                                          )}
                                          value={KieuLaiSuat}
                                          defaultValue={KieuLaiSuat}
                                          disabled={IsEditChoVay}
                                        >
                                          {bindKieuLaiSuat(
                                            objConfigSysLoaiTS,
                                            TypePaid,
                                          )}
                                        </select>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12"></div>
                                {OptionTinhLai === ConfigConst.ShowDate ? (
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Ngày trả{" "}
                                      <span className="canh-bao-red">*</span>
                                    </label>
                                    <br />
                                    <DateTimePicker
                                      onChange={onChangeNgayTraGoc}
                                      value={NgayTraGoc}
                                      name="NgayTraGoc"
                                      customInputRef={register({
                                        required: "Hãy nhập ngày trả",
                                      })}
                                      customInput={
                                        <input
                                          name="NgayTraGoc"
                                          ref={register}
                                        ></input>
                                      }
                                      readOnly={IsEditChoVay}
                                    ></DateTimePicker>
                                    {/* <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-calendar"></i>
                                      </span>
                                    </div> */}
                                  </div>
                                ) : IsTongSoNgay ? (
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="col-md-2 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-4"
                                      wrapperClass="form-group row"
                                      labelText="Số ngày trả lãi"
                                      starRed="*"
                                      placeholder="12"
                                      inputProps={{
                                        name: "TongNgayVay",
                                        value: TongNgayVay,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "TongNgayVay",
                                          ),
                                        rules: {
                                          required: "Hãy nhập tổng số ngày trả",
                                        },
                                        control: control,
                                        disabled: IsEditChoVay,
                                      }}
                                      error={errors.TongNgayVay}
                                    ></NumberInput>
                                  </div>
                                ) : (
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="col-md-2 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-4"
                                      wrapperClass="form-group row"
                                      labelText="Số kỳ đóng lãi"
                                      starRed="*"
                                      toolTip
                                      textToolTip="Số kỳ trả 10 kỳ điền số 10"
                                      placeholder="12"
                                      inputProps={{
                                        name: "SoLanTra",
                                        value: SoLanTra,
                                        onChange:
                                          onChangeAttNumberChoVay("SoLanTra"),
                                        rules: {
                                          required: "Hãy nhập số kỳ đóng lãi",
                                        },
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                      error={errors.SoLanTra}
                                    ></NumberInput>
                                  </div>
                                )}

                                {cauHinhThuKyDau === true && (
                                  <div className="col-md-4">
                                    {" "}
                                    <NumberInput
                                      labelClass="col-md-2 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-4"
                                      wrapperClass="form-group row"
                                      labelText="Số tiền thu kỳ đầu"
                                      placeholder="0"
                                      inputProps={{
                                        name: "SoTienThuKyDau",
                                        value: SoTienThuKyDau,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "SoTienThuKyDau",
                                          ),
                                        // rules: {
                                        //   required: "Hãy nhập số tiền vay",
                                        // },
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                      // error={errors.SoTienThuKyDau}
                                    ></NumberInput>
                                  </div>
                                )}

                                <div className="col-md-12"></div>
                                <div
                                  className={
                                    "col-md-4" +
                                    (objConfigSysLoaiTS._allBeforeAfterTinChapCamDo
                                      ? ""
                                      : " hidden")
                                  }
                                >
                                  <label className="label-control color7-bold">
                                    Kiểu thu lãi{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <br />
                                  <select
                                    name="BeforeAfter"
                                    className="form-control input-sm select-v2"
                                    ref={register}
                                    value={BeforeAfter}
                                    onChange={onChangeAttTextChoVay(
                                      "BeforeAfter",
                                    )}
                                    disabled={IsEditChoVay}
                                  >
                                    <option value="1">Sau</option>
                                    <option value="2">Trước</option>
                                  </select>
                                </div>
                                {batHinhThucThanhToan && (
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Hình thức thanh toán
                                    </label>
                                    <br />
                                    <select
                                      className="form-control input-sm select-v2"
                                      value={hinhThucThanhToan}
                                      onChange={(e) =>
                                        setHinhThucThanhToan(e.target.value)
                                      }
                                       disabled={IsEditChoVay}
                                    >
                                      <option value="0">Tiền mặt</option>
                                      <option value="1">Chuyển khoản</option>
                                    </select>
                                  </div>
                                )}
                                {IsSoNgayTatToan && (
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="col-md-2 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-4"
                                      wrapperClass="form-group row"
                                      labelText="Làm tròn tiền/ngày"
                                      placeholder="1"
                                      inputProps={{
                                        name: "SoNgayTinhLaiTruocHan",
                                        value: SoNgayToiThieu,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "SoNgayToiThieu",
                                          ),
                                        control: control,
                                        disabled: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                )}
                                <div className="col-md-12"></div>
                                {IsGiaHanTuDong && (
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="label-control color7-bold"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-4"
                                      wrapperClass="form-group row"
                                      labelText="Thêm ngày quá hạn"
                                      placeholder="1"
                                      inputProps={{
                                        name: "SoNgayGiaHanTuDong",
                                        value: SoNgayGiaHan,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "SoNgayGiaHan",
                                          ),
                                        control: control,
                                        disabled: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                )}
                              </>
                            )}
                            {SuDungPhiPhat_DongLai_TatToan &&
                              isDuNoGiamDan === false && (
                                <>
                                  <div className="col-md-12"></div>
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="label-control color7-bold"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-6"
                                      labelText="Phạt chậm đóng lãi"
                                      wrapperClass="form-group row"
                                      inputProps={{
                                        name: "PhiPhatTraLai",
                                        value: PhiPhatTraLai,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "PhiPhatTraLai",
                                          ),
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                  <div className="col-md-4 radio-button-nhap-tien">
                                    <label className="custom-radio">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTraLai"
                                        onChange={onChangeLoaiPhiPhatTraLai(1)}
                                        checked={
                                          intLoaiPhiPhatTraLai === 1
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập tiền
                                    </label>
                                    <label className="custom-radio radio-button-nhap-phan-tram">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTraLai"
                                        onChange={onChangeLoaiPhiPhatTraLai(2)}
                                        checked={
                                          intLoaiPhiPhatTraLai === 2
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập %
                                    </label>
                                  </div>
                                </>
                              )}
                            {SuDungTatToanSom && (
                              <>
                                <div className="col-md-12"></div>
                                <div className="col-md-4">
                                  <NumberInput
                                    labelClass="label-control color7-bold"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-6"
                                    labelText="Phạt tất toán sớm"
                                    wrapperClass="form-group row"
                                    inputProps={{
                                      name: "PhiPhatTatToan",
                                      value: PhiPhatTatToan,
                                      onChange:
                                        onChangeAttNumberChoVay(
                                          "PhiPhatTatToan",
                                        ),
                                      control: control,
                                      readOnly: IsEditChoVay,
                                    }}
                                  ></NumberInput>
                                </div>
                                <div className="col-md-4 radio-button-nhap-tien">
                                  <label className="custom-radio">
                                    <input
                                      type="radio"
                                      name="LoaiPhiPhatTatToan"
                                      onChange={onChangeLoaiPhiPhatTatToan(1)}
                                      checked={
                                        intLoaiPhiPhatTatToan === 1
                                          ? true
                                          : false
                                      }
                                      disabled={IsEditChoVay}
                                    />{" "}
                                    <span className="radio-mark"></span>
                                    Nhập tiền
                                  </label>
                                  <label className="custom-radio radio-button-nhap-phan-tram">
                                    <input
                                      type="radio"
                                      name="LoaiPhiPhatTatToan"
                                      onChange={onChangeLoaiPhiPhatTatToan(2)}
                                      checked={
                                        intLoaiPhiPhatTatToan === 2
                                          ? true
                                          : false
                                      }
                                      disabled={IsEditChoVay}
                                    />{" "}
                                    <span className="radio-mark"></span>
                                    Nhập %
                                  </label>
                                </div>
                              </>
                            )}
                            {SuDungCongTacVienNhanVien && (
                              <>
                                <div className="col-md-12"></div>
                                <div className="col-md-4">
                                  <TextInputTwoRow
                                    labelClass="col-md-2 label-control"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-4"
                                    wrapperClass="form-group row"
                                    labelText="Mã nhân viên"
                                    placeholder="Mã nhân viên"
                                    inputProps={{
                                      name: "MaNhanVien",
                                      onChange:
                                        onChangeAttTextChoVay("MaNhanVien"),
                                      value: MaNhanVien,
                                    }}
                                  ></TextInputTwoRow>
                                </div>
                              </>
                            )}
                            {SuDungMaNhanVien && listNhanVien.length > 1 && (
                              <>
                                <div className="col-md-12"></div>
                                <div className="col-md-4">
                                  <label className="color7-bold">
                                    Nhân viên
                                  </label>

                                  <select
                                    name="MaNhanVien"
                                    className="form-control input-sm"
                                    ref={register}
                                    value={MaNhanVien}
                                    defaultValue={""}
                                    disabled={IsEditChoVay}
                                    onChange={onChangeAttTextChoVay(
                                      "MaNhanVien",
                                    )}
                                  >
                                    {listNhanVien.length > 1 && (
                                      <option value="">
                                        -- Chọn nhân viên --
                                      </option>
                                    )}
                                    {listNhanVien &&
                                      listNhanVien.map((nv) => (
                                        <option value={nv.value}>
                                          {nv.label}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                              </>
                            )}
                            <div className="col-md-12">
                              <label className="label-control color7-bold">
                                Ghi chú
                              </label>
                              <textarea
                                rows="1"
                                style={{ minHeight: "80px" }}
                                className="textarea-customer input-sm"
                                name="Note"
                                placeholder=""
                                value={Note}
                                onChange={onChangeAttTextChoVay("Note")}
                                ref={register}
                                disabled={IsEditChoVay}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse19412"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse19412"
                  aria-expanded="false"
                  aria-controls="collapse194"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Các loại phí</h3>
                  </a>
                </div>
                <div
                  id="collapse19412"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 col-lg-12">
                          {objListPhiKhac &&
                            objListPhiKhac.map((item, idx) => (
                              <div key={"phiKhac" + idx}>
                                <div className="row">
                                  <div className="col-md-6">
                                    <NumberInput
                                      labelClass="col-md-6 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-6"
                                      wrapperClass="form-group row"
                                      labelText={item.TenPhiKhac}
                                      inputProps={{
                                        name: "ListPhiKhac[" + idx + "].GiaTri",
                                        value: objListPhiKhac[idx].GiaTri,
                                        onChange: onChangePhiKhac(idx),
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                  <div className="col-md-6">
                                    {item.LoaiPhiKhac == 1 ? (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="1"
                                              checked={true}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập tiền
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="2"
                                              checked={false}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    ) : item.LoaiPhiKhac == 2 ? (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="1"
                                              checked={false}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="2"
                                              checked={true}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhacChon"
                                              }
                                              value="1"
                                              checked={
                                                objListPhiKhac[idx]
                                                  .LoaiPhiKhacChon === 1
                                                  ? true
                                                  : false
                                              }
                                              ref={register}
                                              disabled={IsEditChoVay}
                                              onChange={onChangeLoaiPhiKhac(
                                                idx,
                                                1,
                                              )}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập tiền
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhacChon"
                                              }
                                              value="2"
                                              checked={
                                                objListPhiKhac[idx]
                                                  .LoaiPhiKhacChon === 2
                                                  ? true
                                                  : false
                                              }
                                              ref={register}
                                              disabled={IsEditChoVay}
                                              onChange={onChangeLoaiPhiKhac(
                                                idx,
                                                2,
                                              )}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <input
                                  type="hidden"
                                  name={
                                    "ListPhiKhac[" + idx + "].ConfigPhiKhacId"
                                  }
                                  value={item.ConfigPhiKhacId}
                                  ref={register}
                                />
                                <input
                                  type="hidden"
                                  name={"ListPhiKhac[" + idx + "].LoaiPhiKhac"}
                                  value={item.LoaiPhiKhac}
                                  ref={register}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {IsSuDungPhiKhacHangKy == true &&
                    objListPhiKhacHangKy != undefined &&
                    objListPhiKhacHangKy.length > 0 && (
                      <>
                        <div
                          id="headingCollapse194121"
                          className="card-header  mt-1"
                          data-toggle="collapse"
                          href="#collapse194121"
                          aria-expanded="false"
                          aria-controls="collapse1941"
                        >
                          <a
                            className="card-title lead info collapsed"
                            href={() => false}
                          >
                            <h3>Các loại phí hàng kỳ</h3>
                          </a>
                        </div>
                        <div
                          id="collapse194121"
                          role="tabpanel"
                          aria-labelledby="headingCollapse194121"
                          className="card-collapse collapse"
                        >
                          <div className="card-content">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-12 col-lg-12">
                                  {objListPhiKhacHangKy &&
                                    objListPhiKhacHangKy.map((item, idx) => (
                                      <div key={"phiKhacHangKy" + idx}>
                                        <div className="row">
                                          <div className="col-md-6">
                                            <NumberInput
                                              labelClass="col-md-6 label-control"
                                              inputClass="form-control input-sm"
                                              inputWrapClass="col-md-6"
                                              wrapperClass="form-group row"
                                              labelText={item.TenPhiKhacHangKy}
                                              inputProps={{
                                                name:
                                                  "ListPhiKhacHangKy[" +
                                                  idx +
                                                  "].GiaTri",
                                                value:
                                                  objListPhiKhacHangKy[idx]
                                                    .GiaTri,
                                                onChange:
                                                  onChangePhiKhacHangKy(idx),
                                                control: control,
                                                readOnly: IsEditChoVay,
                                              }}
                                            ></NumberInput>
                                          </div>
                                          <div className="col-md-6">
                                            {item.LoaiPhiKhacHangKy == 1 ? (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="1"
                                                      checked={true}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>

                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="2"
                                                      checked={false}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            ) : item.LoaiPhiKhacHangKy == 2 ? (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="1"
                                                      checked={false}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>
                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="2"
                                                      checked={true}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKyChon"
                                                      }
                                                      value="1"
                                                      checked={
                                                        objListPhiKhacHangKy[
                                                          idx
                                                        ]
                                                          .LoaiPhiKhacHangKyChon ===
                                                        1
                                                          ? true
                                                          : false
                                                      }
                                                      ref={register}
                                                      disabled={IsEditChoVay}
                                                      onChange={onChangeLoaiPhiKhacHangKy(
                                                        idx,
                                                        1,
                                                      )}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>

                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKyChon"
                                                      }
                                                      value="2"
                                                      checked={
                                                        objListPhiKhacHangKy[
                                                          idx
                                                        ]
                                                          .LoaiPhiKhacHangKyChon ===
                                                        2
                                                          ? true
                                                          : false
                                                      }
                                                      ref={register}
                                                      disabled={IsEditChoVay}
                                                      onChange={onChangeLoaiPhiKhacHangKy(
                                                        idx,
                                                        2,
                                                      )}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                        <input
                                          type="hidden"
                                          name={
                                            "ListPhiKhacHangKy[" +
                                            idx +
                                            "].ConfigPhiKhacHangKyId"
                                          }
                                          value={item.ConfigPhiKhacHangKyId}
                                          ref={register}
                                        />
                                        <input
                                          type="hidden"
                                          name={
                                            "ListPhiKhacHangKy[" +
                                            idx +
                                            "].LoaiPhiKhacHangKy"
                                          }
                                          value={item.LoaiPhiKhacHangKy}
                                          ref={register}
                                        />
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse191"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse191"
                  aria-expanded="false"
                  aria-controls="collapse191"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin tài sản thế chấp</h3>
                  </a>
                </div>
                <div
                  id="collapse191"
                  role="tabpanel"
                  aria-labelledby="headingCollapse191"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <input
                            type="hidden"
                            name="ListHangTheChap[0].CategoryId"
                            value={CategoryId}
                            ref={register}
                          ></input>
                          <div className="row">
                            {ThuocTinhTaiSan &&
                              ThuocTinhTaiSan.map((item, index) => (
                                <div
                                  className="col-md-3"
                                  key={"Thuoctinhts1" + index}
                                >
                                  <TextInputOnRow
                                    labelClass="label-control color7-bold"
                                    inputClass="form-control input-sm"
                                    wrapperClass="form-group"
                                    labelText={item.TenThuocTinh}
                                    inputProps={{
                                      ref: register,
                                      name:
                                        "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                        index +
                                        "].OptionValue",
                                      onChange: onChangeThuocTinhTaiSan(index),
                                      value: ThuocTinhTaiSan[index].OptionValue,
                                    }}
                                  ></TextInputOnRow>
                                  <input
                                    type="hidden"
                                    name={
                                      "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                      index +
                                      "].OptionName"
                                    }
                                    value={item.MaThuocTinh}
                                    ref={register}
                                  ></input>
                                </div>
                              ))}

                            <div className="col-md-3">
                              <div className="form-group">
                                <label className="label-control color7-bold">
                                  Kho
                                </label>
                                <select
                                  name="ListHangTheChap[0].StoreID"
                                  className="selectBox form-control input-sm select-v2"
                                  ref={register}
                                  value={StoreID}
                                  onChange={setAttTaiSan("StoreID")}
                                >
                                  {objComboStore &&
                                    objComboStore.map((item, idx) => (
                                      <option
                                        key={"objComboStore1" + idx}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Mã tài sản"
                                inputProps={{
                                  ref: register,
                                  name: "ListHangTheChap[0].Code",
                                  onChange: setAttTaiSan("MaTaiSan"),
                                  value: MaTaiSan,
                                }}
                              ></TextInputOnRow>
                            </div>
                            {ConfigPhiKho === 1 && (
                              <div className={"col-md-3 "}>
                                <div className="form-group">
                                  <label className="label-control color7-bold">
                                    Phí kho/ngày
                                  </label>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    prefix={""}
                                    inputMode="numeric"
                                    className="form-control input-sm"
                                    placeholder="%"
                                    name="ListHangTheChap[0].PhiKho"
                                    onChange={setAttTaiSan("PhiKho")}
                                    value={PhiKho}
                                    getInputRef={register}
                                  />
                                </div>
                              </div>
                            )}

                            <div
                              className="col-md-12"
                              style={{ marginTop: "10px" }}
                            >
                              <div className="form-group">
                                <label className="label-control color7-bold">
                                  Ghi chú
                                </label>
                                <textarea
                                  rows="1"
                                  style={{ minHeight: "80px" }}
                                  className="form-control input-sm text-era"
                                  name="ListHangTheChap[0].Note"
                                  placeholder="Ghi chú"
                                  ref={register}
                                  onChange={setAttTaiSan("Note")}
                                  value={NoteTaiSan}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 mt-1">
                          <div className="row">
                            <div className="col-md-12">
                              <UploadMultiFile
                                Files={imageTaiSans}
                                onChange={setImageTaiSans}
                                Code={thongTinCuaHang.Code}
                              ></UploadMultiFile>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group overflow-hidden form-actions text-right">
                      <button
                        type="button"
                        className="btn-them-moi-ts"
                        onClick={() => onClickShowAddNewTaiSan(true)}
                        style={{ margin: "0px" }}
                      >
                        <i className="mdi mdi-plus"></i>{" "}
                        <span style={{ fontSize: "15px" }}>
                          Thêm tài sản khác
                        </span>
                      </button>
                    </div>
                    <div className={showAddNewTaiSan ? "" : "hidden"}>
                      <ListTaiSanForm
                        comboLoaiTaiSan={ListLoaiTaiSan}
                        getThuocTinhTaiSan1={getThuocTinhTaiSan1}
                        listTaiSan={ListTaiSanCamCo}
                        onChange={onChangeListTaiSan}
                        thuoctinhtaisan={thuoctinhtaisan}
                        objComboStore={objComboStore}
                        cauHinhPhiKho={PhiKho}
                        codeCuaHang={thongTinCuaHang.Code}
                      ></ListTaiSanForm>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse191191"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse191191"
                  aria-expanded="false"
                  aria-controls="collapse194"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Đính kèm file</h3>
                  </a>
                </div>
                <div
                  id="collapse191191"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 col-lg-12">
                          <UploadMultiFile1
                            Files={fileDinhKems}
                            onChange={setFileDinhKems}
                            Code={thongTinCuaHang.Code}
                          ></UploadMultiFile1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          {/* {!postCamDoLoading && (
            <button className="btn btn-new-main btn-checknew" type="submit">
              <span className="btn-icon-left">
                <i className="mdi mdi-check"></i>
              </span>{" "}
              {camdo_sudungchoduyet ? "Chờ duyệt" : "Lưu lại"}
            </button>
          )} */}
          <div className="from-button-modal">
            <div className="row">
              <div className="col-md-4">
                {ChoVayId == 0 && useLichThanhToan && (
                  <button
                    className="btn btn-new-main btn-lichthanhtoan"
                    type="submit"
                    Name="button1"
                    onClick={() => (state.button = 2)}
                  >
                    <span>
                      <i className="mdi mdi-check"></i>
                    </span>{" "}
                    Lịch thanh toán chi phí vay
                  </button>
                )}
              </div>
              <div className="col-md-8 text-right">
                {CanhBaoSoHopDong != "" && (
                  <span style={{ color: "red" }}>{CanhBaoSoHopDong}</span>
                )}
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  href={() => false}
                  onClick={closeThemMoi()}
                >
                  <span>
                    <i class="mdi mdi-close"></i>
                  </span>
                  &nbsp; Đóng &nbsp;
                </button>
                {!postCamDoLoading &&
                  HasKySo !== 1 &&
                  HasTatToanChoDuyet !== 1 && (
                    <>
                      {isDisable !== true && (
                        <button
                          className="btn btn-new-main btn-checknew"
                          type="submit"
                        >
                          <span>
                            <img src="/app-assets/images/icon-save-v2-white.png" />
                          </span>{" "}
                          {camdo_sudungchoduyet && ChoVayId == 0
                            ? "Chờ duyệt"
                            : "Lưu lại"}
                        </button>
                      )}
                    </>
                  )}
                {showButtonIn &&
                  (isCauHinhQuyTrinhPheDuyet == false ||
                    camdo_sudungchoduyet == false ||
                    (camdo_sudungchoduyet == true &&
                      camdo_inchoduyet == true)) && (
                    <button
                      className="btn btn-new-main btn-checknew"
                      href={() => false}
                      onClick={inHopDong(choVayEdit)}
                      type="button"
                    >
                      <span className="btn-icon-left">
                        <i className="mdi mdi-printer"></i>
                      </span>{" "}
                      &nbsp; In hợp đồng &nbsp;
                    </button>
                  )}

                {showButtonInPhieuThu &&
                  !camdo_sudungchoduyet &&
                  ThuChiId > 0 && (
                    <button
                      className="btn btn-new-main btn-checknew"
                      href={() => false}
                      onClick={inPhieuThu(ThuChiId)}
                      type="button"
                    >
                      <span className="btn-icon-left">
                        <i className="mdi mdi-printer"></i>
                      </span>{" "}
                      &nbsp; In phiếu thu &nbsp;
                    </button>
                  )}
              </div>
            </div>
          </div>
        </Modal.Footer>

        {isShowModalThuocTinhGiamTru && (
          <>
            <ThuocTinhGiamTruModal
              show={isShowModalThuocTinhGiamTru}
              data={ListThuocTinhGiamTru}
              giagoivay={GiaGoiVay}
              setGiaGoiVay={setGiaGoiVay}
              giasanpham={GiaSanPham}
              setGiaSanPham={setGiaSanPham}
              listThuocTinhGiamTruSelect={ListThuocTinhGiamTruSelect}
              setListThuocTinhGiamTruSelect={setListThuocTinhGiamTruSelect}
              setTongTienGiamTruSelect={setTongTienGiamTruSelect}
              onHide={setModalThuocTinhGiamTru}
            ></ThuocTinhGiamTruModal>
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: "#000000",
                margin: "0px",
                position: "fixed",
                top: "0",
                left: "0",
                opacity: "0.7",
              }}
            ></div>
          </>
        )}
        {isShowDongLaiXemTruoc && (
          <>
            <ModalDongLaiXemTruoc
              show={isShowDongLaiXemTruoc}
              onHide={hideThanhToanXemTruoc}
              listPaid={thanhToanXemTruoc}
              thongtinThanhToanXemTruoc={thongtinThanhToanXemTruoc}
            />
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: "#000000",
                margin: "0px",
                position: "fixed",
                top: "0",
                left: "0",
                opacity: "0.7",
              }}
            ></div>
          </>
        )}
      </form>
    </Modal>
  );
};

export default ChoVayForm;
